﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }
}

@Injectable()
export class BookingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param bookingId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    cancel(bookingId: string | null | undefined, comment: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/booking/Cancel?";
        if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&"; 
        if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getavailable(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<ListResultDtoOfDateTime> {
        let url_ = this.baseUrl + "/booking/getavailable?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetavailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetavailable(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDateTime>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDateTime>><any>_observableThrow(response_);
        }));
    }

    protected processGetavailable(response: HttpResponseBase): Observable<ListResultDtoOfDateTime> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDateTime.fromJS(resultData200) : new ListResultDtoOfDateTime();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDateTime>(<any>null);
    }

    /**
     * @param bookingId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    reschedule(bookingId: string | null | undefined, comment: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/booking/reschedule?";
        if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&"; 
        if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReschedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReschedule(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processReschedule(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class BranchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateBranchDto | null | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchDto.fromJS(resultData200) : new BranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: BranchDto | null | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchDto.fromJS(resultData200) : new BranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * @return Success
     */
    getBranches(): Observable<ListResultDtoOfBranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetBranches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranches(response: HttpResponseBase): Observable<ListResultDtoOfBranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBranchDto.fromJS(resultData200) : new ListResultDtoOfBranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBranchDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<BranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BranchDto.fromJS(resultData200) : new BranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchDto>(<any>null);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getUserFilteredBranches(countryCode: string | null | undefined): Observable<ListResultDtoOfBranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetUserFilteredBranches?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserFilteredBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserFilteredBranches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserFilteredBranches(response: HttpResponseBase): Observable<ListResultDtoOfBranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBranchDto.fromJS(resultData200) : new ListResultDtoOfBranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBranchDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUserFilteredCountryCodes(): Observable<ListResultDtoOfCountryCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetUserFilteredCountryCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserFilteredCountryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserFilteredCountryCodes(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCountryCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCountryCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserFilteredCountryCodes(response: HttpResponseBase): Observable<ListResultDtoOfCountryCodeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCountryCodeDto.fromJS(resultData200) : new ListResultDtoOfCountryCodeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCountryCodeDto>(<any>null);
    }

    /**
     * @param displayName (optional) 
     * @param primaryEmail (optional) 
     * @param primaryPhone (optional) 
     * @param country (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(displayName: string | null | undefined, primaryEmail: string | null | undefined, primaryPhone: string | null | undefined, country: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfBranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Branch/GetAll?";
        if (displayName !== undefined)
            url_ += "DisplayName=" + encodeURIComponent("" + displayName) + "&"; 
        if (primaryEmail !== undefined)
            url_ += "PrimaryEmail=" + encodeURIComponent("" + primaryEmail) + "&"; 
        if (primaryPhone !== undefined)
            url_ += "PrimaryPhone=" + encodeURIComponent("" + primaryPhone) + "&"; 
        if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBranchDto.fromJS(resultData200) : new PagedResultDtoOfBranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Branch/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CommentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    getbyinspectionid(inspectionId: string | null | undefined): Observable<ListResultDtoOfCommentThreadDto> {
        let url_ = this.baseUrl + "/comment/getbyinspectionid?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyinspectionid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyinspectionid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCommentThreadDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCommentThreadDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyinspectionid(response: HttpResponseBase): Observable<ListResultDtoOfCommentThreadDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCommentThreadDto.fromJS(resultData200) : new ListResultDtoOfCommentThreadDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCommentThreadDto>(<any>null);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    getcommentthreadbyid(commentId: string | null | undefined): Observable<ListResultDtoOfCommentsListDto> {
        let url_ = this.baseUrl + "/comment/getcommentthreadbyid?";
        if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetcommentthreadbyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetcommentthreadbyid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCommentsListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCommentsListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetcommentthreadbyid(response: HttpResponseBase): Observable<ListResultDtoOfCommentsListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCommentsListDto.fromJS(resultData200) : new ListResultDtoOfCommentsListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCommentsListDto>(<any>null);
    }

    /**
     * @param commentId (optional) 
     * @param message (optional) 
     * @return Success
     */
    respondtoacomment(commentId: string | null | undefined, message: string | null | undefined): Observable<CommentsListDto> {
        let url_ = this.baseUrl + "/comment/respondtoacomment?";
        if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&"; 
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRespondtoacomment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRespondtoacomment(<any>response_);
                } catch (e) {
                    return <Observable<CommentsListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommentsListDto>><any>_observableThrow(response_);
        }));
    }

    protected processRespondtoacomment(response: HttpResponseBase): Observable<CommentsListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CommentsListDto.fromJS(resultData200) : new CommentsListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentsListDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param inspectionPointId (optional) 
     * @return Success
     */
    getByInspectionIdAndInspectionPointId(inspectionId: string | null | undefined, inspectionPointId: string | null | undefined): Observable<CommentsListDto> {
        let url_ = this.baseUrl + "/comment/GetByInspectionIdAndInspectionPointId?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (inspectionPointId !== undefined)
            url_ += "inspectionPointId=" + encodeURIComponent("" + inspectionPointId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByInspectionIdAndInspectionPointId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByInspectionIdAndInspectionPointId(<any>response_);
                } catch (e) {
                    return <Observable<CommentsListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommentsListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByInspectionIdAndInspectionPointId(response: HttpResponseBase): Observable<CommentsListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CommentsListDto.fromJS(resultData200) : new CommentsListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentsListDto>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeTenantUiTheme(input: ChangeUiThemeInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeTenantUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTenantUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTenantUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeTenantUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    saveTenantBranding(input: TenantBrandingInput | null | undefined): Observable<TenantBrandingInput> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/SaveTenantBranding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTenantBranding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTenantBranding(<any>response_);
                } catch (e) {
                    return <Observable<TenantBrandingInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantBrandingInput>><any>_observableThrow(response_);
        }));
    }

    protected processSaveTenantBranding(response: HttpResponseBase): Observable<TenantBrandingInput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantBrandingInput.fromJS(resultData200) : new TenantBrandingInput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantBrandingInput>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantCustomCSS(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetTenantCustomCSS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCustomCSS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCustomCSS(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantCustomCSS(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantLogo(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetTenantLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantCustomCSSPerTenant(tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetTenantCustomCSSPerTenant?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCustomCSSPerTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCustomCSSPerTenant(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantCustomCSSPerTenant(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLogoForTenant(tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetLogoForTenantAsync?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogoForTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoForTenant(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogoForTenant(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param logoFile Uploaded Logo
     * @return Success
     */
    uploadLogo(logoFile: FileParameter): Observable<UploadLogoResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UploadLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logoFile === null || logoFile === undefined)
            throw new Error("The parameter 'logoFile' cannot be null.");
        else
            content_.append("logoFile", logoFile.data, logoFile.fileName ? logoFile.fileName : "logoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLogo(<any>response_);
                } catch (e) {
                    return <Observable<UploadLogoResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadLogoResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadLogo(response: HttpResponseBase): Observable<UploadLogoResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UploadLogoResponseDto.fromJS(resultData200) : new UploadLogoResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadLogoResponseDto>(<any>null);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    create(request: CustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/customer/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerDto.fromJS(resultData200) : new CustomerDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    update(request: CustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/customer/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerDto.fromJS(resultData200) : new CustomerDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getbyid(customerId: string | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/customer/getbyid?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyid(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyid(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CustomerDto.fromJS(resultData200) : new CustomerDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: CustomerSearchRequestDto | null | undefined): Observable<ListResultDtoOfCustomerDto> {
        let url_ = this.baseUrl + "/customer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ListResultDtoOfCustomerDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCustomerDto.fromJS(resultData200) : new ListResultDtoOfCustomerDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCustomerDto>(<any>null);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBranches(): Observable<ListResultDtoOfBranchDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetBranches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBranchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranches(response: HttpResponseBase): Observable<ListResultDtoOfBranchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBranchDto.fromJS(resultData200) : new ListResultDtoOfBranchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBranchDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCountryCodes(): Observable<ListResultDtoOfCountryCodeDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetCountryCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryCodes(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCountryCodeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCountryCodeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryCodes(response: HttpResponseBase): Observable<ListResultDtoOfCountryCodeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCountryCodeDto.fromJS(resultData200) : new ListResultDtoOfCountryCodeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCountryCodeDto>(<any>null);
    }
}

@Injectable()
export class EmailNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateEmailNotificationDto | null | undefined): Observable<EmailNotificationDto> {
        let url_ = this.baseUrl + "/emailNotification/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmailNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotificationDto.fromJS(resultData200) : new EmailNotificationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotificationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    delete(input: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emailNotification/delete?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    get(input: string | null | undefined): Observable<EmailNotificationDto> {
        let url_ = this.baseUrl + "/emailNotification/getAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotificationDto.fromJS(resultData200) : new EmailNotificationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotificationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getall(input: PagedEmailNotificationResultRequestDto | null | undefined): Observable<ListResultDtoOfEmailNotificationDto> {
        let url_ = this.baseUrl + "/emailNotification/getall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetall(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEmailNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEmailNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetall(response: HttpResponseBase): Observable<ListResultDtoOfEmailNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEmailNotificationDto.fromJS(resultData200) : new ListResultDtoOfEmailNotificationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEmailNotificationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: EmailNotificationDto | null | undefined): Observable<EmailNotificationDto> {
        let url_ = this.baseUrl + "/emailNotification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EmailNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EmailNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmailNotificationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EmailNotificationDto.fromJS(resultData200) : new EmailNotificationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotificationDto>(<any>null);
    }
}

@Injectable()
export class StandardPPIServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    list(): Observable<ListResultDtoOfIconListDto> {
        let url_ = this.baseUrl + "/icons/standardPPI/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListResultDtoOfIconListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIconListDto.fromJS(resultData200) : new ListResultDtoOfIconListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfIconListDto>(<any>null);
    }
}

@Injectable()
export class ObservationstatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    list(): Observable<ListResultDtoOfIconListDto> {
        let url_ = this.baseUrl + "/icons/observationstatus/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListResultDtoOfIconListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIconListDto.fromJS(resultData200) : new ListResultDtoOfIconListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfIconListDto>(<any>null);
    }
}

@Injectable()
export class ThlcriteriaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    list(): Observable<ListResultDtoOfIconListDto> {
        let url_ = this.baseUrl + "/icons/thlcriteria/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfIconListDto>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListResultDtoOfIconListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIconListDto.fromJS(resultData200) : new ListResultDtoOfIconListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfIconListDto>(<any>null);
    }
}

@Injectable()
export class InspectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    update(request: InspectionUpdateRequestDto | null | undefined): Observable<InspectionListResponseDto> {
        let url_ = this.baseUrl + "/inspection/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<InspectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InspectionListResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionListResponseDto.fromJS(resultData200) : new InspectionListResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionListResponseDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    create(request: InspectionCreateRequestDto | null | undefined): Observable<InspectionListResponseDto> {
        let url_ = this.baseUrl + "/inspection/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<InspectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InspectionListResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionListResponseDto.fromJS(resultData200) : new InspectionListResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionListResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    getbyinspectionid(inspectionId: string | null | undefined): Observable<InspectionListResponseDto> {
        let url_ = this.baseUrl + "/inspection/getbyinspectionid?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyinspectionid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyinspectionid(<any>response_);
                } catch (e) {
                    return <Observable<InspectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyinspectionid(response: HttpResponseBase): Observable<InspectionListResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionListResponseDto.fromJS(resultData200) : new InspectionListResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionListResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param inspectionName (optional) 
     * @return Success
     */
    updatestatus(inspectionId: string | null | undefined, inspectionName: string | null | undefined): Observable<InspectionListResponseDto> {
        let url_ = this.baseUrl + "/inspection/updatestatus?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (inspectionName !== undefined)
            url_ += "inspectionName=" + encodeURIComponent("" + inspectionName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatestatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatestatus(<any>response_);
                } catch (e) {
                    return <Observable<InspectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatestatus(response: HttpResponseBase): Observable<InspectionListResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionListResponseDto.fromJS(resultData200) : new InspectionListResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionListResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    delete(inspectionId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/inspection/delete?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param branchIds (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getbookings(branchIds: string[] | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined): Observable<ListResultDtoOfBookingListDto> {
        let url_ = this.baseUrl + "/inspection/getbookings?";
        if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&"; 
        if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branchIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbookings(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBookingListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBookingListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbookings(response: HttpResponseBase): Observable<ListResultDtoOfBookingListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfBookingListDto.fromJS(resultData200) : new ListResultDtoOfBookingListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBookingListDto>(<any>null);
    }

    /**
     * @param bookingId (optional) 
     * @return Success
     */
    createfrombooking(bookingId: string | null | undefined): Observable<InspectionListResponseDto> {
        let url_ = this.baseUrl + "/inspection/createfrombooking?";
        if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatefrombooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatefrombooking(<any>response_);
                } catch (e) {
                    return <Observable<InspectionListResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionListResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatefrombooking(response: HttpResponseBase): Observable<InspectionListResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionListResponseDto.fromJS(resultData200) : new InspectionListResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionListResponseDto>(<any>null);
    }

    /**
     * @param filters (optional) 
     * @return Success
     */
    getrecent(filters: PagedResultRequestDto | null | undefined): Observable<ListResultDtoOfRecentInspectionListDto> {
        let url_ = this.baseUrl + "/inspection/getrecent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetrecent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetrecent(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRecentInspectionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRecentInspectionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetrecent(response: HttpResponseBase): Observable<ListResultDtoOfRecentInspectionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRecentInspectionListDto.fromJS(resultData200) : new ListResultDtoOfRecentInspectionListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRecentInspectionListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    updateallsummarizedrecentinspection(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/inspection/updateallsummarizedrecentinspection?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateallsummarizedrecentinspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateallsummarizedrecentinspection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateallsummarizedrecentinspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    updatesummarizedrecentinspection(inspectionId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/inspection/updatesummarizedrecentinspection?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatesummarizedrecentinspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatesummarizedrecentinspection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatesummarizedrecentinspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    tagInspectionToUser(inspectionId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/inspection/TagInspectionToUser?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagInspectionToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagInspectionToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTagInspectionToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param rego (optional) 
     * @param vin (optional) 
     * @param stockNumber (optional) 
     * @return Success
     */
    vehiclehasinspection(rego: string | null | undefined, vin: string | null | undefined, stockNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/inspection/vehiclehasinspection?";
        if (rego !== undefined)
            url_ += "rego=" + encodeURIComponent("" + rego) + "&"; 
        if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&"; 
        if (stockNumber !== undefined)
            url_ += "stockNumber=" + encodeURIComponent("" + stockNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVehiclehasinspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVehiclehasinspection(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVehiclehasinspection(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    createnewversion(inspectionId: string | null | undefined): Observable<InspectionVersionListDto> {
        let url_ = this.baseUrl + "/inspection/createnewversion?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatenewversion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatenewversion(<any>response_);
                } catch (e) {
                    return <Observable<InspectionVersionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionVersionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatenewversion(response: HttpResponseBase): Observable<InspectionVersionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionVersionListDto.fromJS(resultData200) : new InspectionVersionListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionVersionListDto>(<any>null);
    }

    /**
     * @param vehicleId (optional) 
     * @return Success
     */
    listbyvehicleid(vehicleId: string | null | undefined): Observable<ListResultDtoOfInspectionVersionListDto> {
        let url_ = this.baseUrl + "/inspection/listbyvehicleid?";
        if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListbyvehicleid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListbyvehicleid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionVersionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionVersionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListbyvehicleid(response: HttpResponseBase): Observable<ListResultDtoOfInspectionVersionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionVersionListDto.fromJS(resultData200) : new ListResultDtoOfInspectionVersionListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionVersionListDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    listbyinspectionid(inspectionId: string | null | undefined): Observable<ListResultDtoOfInspectionVersionListDto> {
        let url_ = this.baseUrl + "/inspection/listbyinspectionid?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListbyinspectionid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListbyinspectionid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionVersionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionVersionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListbyinspectionid(response: HttpResponseBase): Observable<ListResultDtoOfInspectionVersionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionVersionListDto.fromJS(resultData200) : new ListResultDtoOfInspectionVersionListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionVersionListDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    pastinspections(request: PastInspectionRequestDto | null | undefined): Observable<ListResultDtoOfPastInspectionsListDto> {
        let url_ = this.baseUrl + "/inspection/pastinspections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPastinspections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPastinspections(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPastInspectionsListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfPastInspectionsListDto>><any>_observableThrow(response_);
        }));
    }

    protected processPastinspections(response: HttpResponseBase): Observable<ListResultDtoOfPastInspectionsListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPastInspectionsListDto.fromJS(resultData200) : new ListResultDtoOfPastInspectionsListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfPastInspectionsListDto>(<any>null);
    }
}

@Injectable()
export class InspectiondetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updatevalue(request: InspectionDetailCreateRequestDto | null | undefined): Observable<InspectionDetailListDto> {
        let url_ = this.baseUrl + "/inspectiondetail/updatevalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatevalue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatevalue(<any>response_);
                } catch (e) {
                    return <Observable<InspectionDetailListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionDetailListDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatevalue(response: HttpResponseBase): Observable<InspectionDetailListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailListDto.fromJS(resultData200) : new InspectionDetailListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionDetailListDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    updatevehiclevalue(request: InspectionDetailCreateRequestDto | null | undefined): Observable<InspectionDetailListDto> {
        let url_ = this.baseUrl + "/inspectiondetail/updatevehiclevalue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatevehiclevalue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatevehiclevalue(<any>response_);
                } catch (e) {
                    return <Observable<InspectionDetailListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionDetailListDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatevehiclevalue(response: HttpResponseBase): Observable<InspectionDetailListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionDetailListDto.fromJS(resultData200) : new InspectionDetailListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionDetailListDto>(<any>null);
    }
}

@Injectable()
export class InspectionpointServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param inspectionTypeId (optional) 
     * @return Success
     */
    listbycategory(inspectionTypeId: string | null | undefined): Observable<ListResultDtoOfCategorizedInspectionPointListDto> {
        let url_ = this.baseUrl + "/inspectionpoint/listbycategory?";
        if (inspectionTypeId !== undefined)
            url_ += "inspectionTypeId=" + encodeURIComponent("" + inspectionTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListbycategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListbycategory(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCategorizedInspectionPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCategorizedInspectionPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListbycategory(response: HttpResponseBase): Observable<ListResultDtoOfCategorizedInspectionPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCategorizedInspectionPointListDto.fromJS(resultData200) : new ListResultDtoOfCategorizedInspectionPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCategorizedInspectionPointListDto>(<any>null);
    }

    /**
     * @return Success
     */
    listbycriteria(): Observable<ListResultDtoOfInspectionPointListDto> {
        let url_ = this.baseUrl + "/inspectionpoint/listbycriteria";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListbycriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListbycriteria(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListbycriteria(response: HttpResponseBase): Observable<ListResultDtoOfInspectionPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionPointListDto.fromJS(resultData200) : new ListResultDtoOfInspectionPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionPointListDto>(<any>null);
    }

    /**
     * @return Success
     */
    listbyinspectiontype(): Observable<ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto> {
        let url_ = this.baseUrl + "/inspectionpoint/listbyinspectiontype";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListbyinspectiontype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListbyinspectiontype(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListbyinspectiontype(response: HttpResponseBase): Observable<ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto.fromJS(resultData200) : new ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto>(<any>null);
    }

    /**
     * @return Success
     */
    listall(): Observable<ListResultDtoOfInspectionPointListDto> {
        let url_ = this.baseUrl + "/inspectionpoint/listall";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListall(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListall(response: HttpResponseBase): Observable<ListResultDtoOfInspectionPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionPointListDto.fromJS(resultData200) : new ListResultDtoOfInspectionPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionPointListDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getbycode(code: string | null | undefined): Observable<InspectionPointListDto> {
        let url_ = this.baseUrl + "/inspectionpoint/getbycode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbycode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbycode(<any>response_);
                } catch (e) {
                    return <Observable<InspectionPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbycode(response: HttpResponseBase): Observable<InspectionPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionPointListDto.fromJS(resultData200) : new InspectionPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionPointListDto>(<any>null);
    }
}

@Injectable()
export class LookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getinspectiontypes(): Observable<ListResultDtoOfInspectionTypesListDto> {
        let url_ = this.baseUrl + "/lookup/getinspectiontypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetinspectiontypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetinspectiontypes(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionTypesListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionTypesListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetinspectiontypes(response: HttpResponseBase): Observable<ListResultDtoOfInspectionTypesListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionTypesListDto.fromJS(resultData200) : new ListResultDtoOfInspectionTypesListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionTypesListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getinspectiontypeswithdraftbyid(id: string | null | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/lookup/getinspectiontypeswithdraftbyid?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetinspectiontypeswithdraftbyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetinspectiontypeswithdraftbyid(<any>response_);
                } catch (e) {
                    return <Observable<InspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetinspectiontypeswithdraftbyid(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeDto.fromJS(resultData200) : new InspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionTypeDto>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param orderColumn (optional) 
     * @return Success
     */
    getbytype(type: string | null | undefined, orderColumn: string | null | undefined): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        let url_ = this.baseUrl + "/lookup/getbytype?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (orderColumn !== undefined)
            url_ += "orderColumn=" + encodeURIComponent("" + orderColumn) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbytype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbytype(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbytype(response: HttpResponseBase): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLK_GenericLookupsDto.fromJS(resultData200) : new ListResultDtoOfLK_GenericLookupsDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLK_GenericLookupsDto>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param initialLetter (optional) 
     * @return Success
     */
    getbytypeandinitialletter(type: string | null | undefined, initialLetter: string | null | undefined): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        let url_ = this.baseUrl + "/lookup/getbytypeandinitialletter?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (initialLetter !== undefined)
            url_ += "initialLetter=" + encodeURIComponent("" + initialLetter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbytypeandinitialletter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbytypeandinitialletter(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbytypeandinitialletter(response: HttpResponseBase): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLK_GenericLookupsDto.fromJS(resultData200) : new ListResultDtoOfLK_GenericLookupsDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLK_GenericLookupsDto>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param parentId (optional) 
     * @return Success
     */
    getbytypeandparentid(type: string | null | undefined, parentId: string | null | undefined): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        let url_ = this.baseUrl + "/lookup/getbytypeandparentid?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbytypeandparentid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbytypeandparentid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbytypeandparentid(response: HttpResponseBase): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLK_GenericLookupsDto.fromJS(resultData200) : new ListResultDtoOfLK_GenericLookupsDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLK_GenericLookupsDto>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param initialLetter (optional) 
     * @param parentId (optional) 
     * @return Success
     */
    getbytypeandinitialletterandparentid(type: string | null | undefined, initialLetter: string | null | undefined, parentId: string | null | undefined): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        let url_ = this.baseUrl + "/lookup/getbytypeandinitialletterandparentid?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (initialLetter !== undefined)
            url_ += "initialLetter=" + encodeURIComponent("" + initialLetter) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbytypeandinitialletterandparentid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbytypeandinitialletterandparentid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLK_GenericLookupsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbytypeandinitialletterandparentid(response: HttpResponseBase): Observable<ListResultDtoOfLK_GenericLookupsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLK_GenericLookupsDto.fromJS(resultData200) : new ListResultDtoOfLK_GenericLookupsDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLK_GenericLookupsDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getbyid(id: string | null | undefined): Observable<LK_GenericLookupsDto> {
        let url_ = this.baseUrl + "/lookup/getbyid?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyid(<any>response_);
                } catch (e) {
                    return <Observable<LK_GenericLookupsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LK_GenericLookupsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyid(response: HttpResponseBase): Observable<LK_GenericLookupsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LK_GenericLookupsDto.fromJS(resultData200) : new LK_GenericLookupsDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LK_GenericLookupsDto>(<any>null);
    }
}

@Injectable()
export class InspectionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    save(input: CreateInspectionTypeDto | null | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<InspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeDto.fromJS(resultData200) : new InspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<InspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeDto.fromJS(resultData200) : new InspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionTypeDto>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param displayName (optional) 
     * @param photoNames (optional) 
     * @param code (optional) 
     * @param inspectionCriteriaId (optional) 
     * @param slug (optional) 
     * @param additionalPhotosAllowed (optional) 
     * @param allowInspectorsToAddCustomers (optional) 
     * @param allowInspectorsToEditCustomers (optional) 
     * @param allowManagerMessageOnReportSummary (optional) 
     * @param disclaimerText (optional) 
     * @param hideDisclaimerText (optional) 
     * @param termsAndConditions (optional) 
     * @param hideTermsAndConditions (optional) 
     * @param explainerCopy (optional) 
     * @param hideExplainerCopy (optional) 
     * @param draft (optional) 
     * @param try1Pager (optional) 
     * @param allowVersioning (optional) 
     * @param changeTireDriveCategoryName (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, displayName: string | null | undefined, photoNames: string | null | undefined, code: string | null | undefined, inspectionCriteriaId: string | null | undefined, slug: string | null | undefined, additionalPhotosAllowed: boolean | null | undefined, allowInspectorsToAddCustomers: boolean | null | undefined, allowInspectorsToEditCustomers: boolean | null | undefined, allowManagerMessageOnReportSummary: boolean | null | undefined, disclaimerText: string | null | undefined, hideDisclaimerText: boolean | null | undefined, termsAndConditions: string | null | undefined, hideTermsAndConditions: boolean | null | undefined, explainerCopy: string | null | undefined, hideExplainerCopy: boolean | null | undefined, draft: boolean | null | undefined, try1Pager: boolean | null | undefined, allowVersioning: boolean | null | undefined, changeTireDriveCategoryName: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfInspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/GetAll?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (displayName !== undefined)
            url_ += "DisplayName=" + encodeURIComponent("" + displayName) + "&"; 
        if (photoNames !== undefined)
            url_ += "PhotoNames=" + encodeURIComponent("" + photoNames) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (inspectionCriteriaId !== undefined)
            url_ += "InspectionCriteriaId=" + encodeURIComponent("" + inspectionCriteriaId) + "&"; 
        if (slug !== undefined)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&"; 
        if (additionalPhotosAllowed !== undefined)
            url_ += "AdditionalPhotosAllowed=" + encodeURIComponent("" + additionalPhotosAllowed) + "&"; 
        if (allowInspectorsToAddCustomers !== undefined)
            url_ += "AllowInspectorsToAddCustomers=" + encodeURIComponent("" + allowInspectorsToAddCustomers) + "&"; 
        if (allowInspectorsToEditCustomers !== undefined)
            url_ += "AllowInspectorsToEditCustomers=" + encodeURIComponent("" + allowInspectorsToEditCustomers) + "&"; 
        if (allowManagerMessageOnReportSummary !== undefined)
            url_ += "AllowManagerMessageOnReportSummary=" + encodeURIComponent("" + allowManagerMessageOnReportSummary) + "&"; 
        if (disclaimerText !== undefined)
            url_ += "DisclaimerText=" + encodeURIComponent("" + disclaimerText) + "&"; 
        if (hideDisclaimerText !== undefined)
            url_ += "HideDisclaimerText=" + encodeURIComponent("" + hideDisclaimerText) + "&"; 
        if (termsAndConditions !== undefined)
            url_ += "TermsAndConditions=" + encodeURIComponent("" + termsAndConditions) + "&"; 
        if (hideTermsAndConditions !== undefined)
            url_ += "HideTermsAndConditions=" + encodeURIComponent("" + hideTermsAndConditions) + "&"; 
        if (explainerCopy !== undefined)
            url_ += "ExplainerCopy=" + encodeURIComponent("" + explainerCopy) + "&"; 
        if (hideExplainerCopy !== undefined)
            url_ += "HideExplainerCopy=" + encodeURIComponent("" + hideExplainerCopy) + "&"; 
        if (draft !== undefined)
            url_ += "Draft=" + encodeURIComponent("" + draft) + "&"; 
        if (try1Pager !== undefined)
            url_ += "Try1Pager=" + encodeURIComponent("" + try1Pager) + "&"; 
        if (allowVersioning !== undefined)
            url_ += "AllowVersioning=" + encodeURIComponent("" + allowVersioning) + "&"; 
        if (changeTireDriveCategoryName !== undefined)
            url_ += "ChangeTireDriveCategoryName=" + encodeURIComponent("" + changeTireDriveCategoryName) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfInspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfInspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfInspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfInspectionTypeDto.fromJS(resultData200) : new PagedResultDtoOfInspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfInspectionTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateInspectionTypeDto | null | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<InspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeDto.fromJS(resultData200) : new InspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CreateInspectionTypeDto | null | undefined): Observable<InspectionTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/InspectionType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<InspectionTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InspectionTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InspectionTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InspectionTypeDto.fromJS(resultData200) : new InspectionTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionTypeDto>(<any>null);
    }
}

@Injectable()
export class LK_InspectionCriteriaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<LK_InspectionCriteriaDto> {
        let url_ = this.baseUrl + "/api/services/app/LK_InspectionCriteria/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LK_InspectionCriteriaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LK_InspectionCriteriaDto.fromJS(resultData200) : new LK_InspectionCriteriaDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LK_InspectionCriteriaDto>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param photoPath (optional) 
     * @param code (optional) 
     * @param dataTypeId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, photoPath: string | null | undefined, code: string | null | undefined, dataTypeId: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfLK_InspectionCriteriaDto> {
        let url_ = this.baseUrl + "/api/services/app/LK_InspectionCriteria/GetAll?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (photoPath !== undefined)
            url_ += "PhotoPath=" + encodeURIComponent("" + photoPath) + "&"; 
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (dataTypeId !== undefined)
            url_ += "DataTypeId=" + encodeURIComponent("" + dataTypeId) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLK_InspectionCriteriaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLK_InspectionCriteriaDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfLK_InspectionCriteriaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLK_InspectionCriteriaDto.fromJS(resultData200) : new PagedResultDtoOfLK_InspectionCriteriaDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLK_InspectionCriteriaDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateInspectionCriteriaDto | null | undefined): Observable<LK_InspectionCriteriaDto> {
        let url_ = this.baseUrl + "/api/services/app/LK_InspectionCriteria/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LK_InspectionCriteriaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LK_InspectionCriteriaDto.fromJS(resultData200) : new LK_InspectionCriteriaDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LK_InspectionCriteriaDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CreateInspectionCriteriaDto | null | undefined): Observable<LK_InspectionCriteriaDto> {
        let url_ = this.baseUrl + "/api/services/app/LK_InspectionCriteria/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LK_InspectionCriteriaDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LK_InspectionCriteriaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LK_InspectionCriteriaDto.fromJS(resultData200) : new LK_InspectionCriteriaDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LK_InspectionCriteriaDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LK_InspectionCriteria/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PhotoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param photoFile Uploaded Photo
     * @return Success
     */
    upload(photoFile: FileParameter, description: string, associationType: string, associationId: string): Observable<UploadPhotoResponseDto> {
        let url_ = this.baseUrl + "/photo/upload?";
        if (description === undefined || description === null)
            throw new Error("The parameter 'description' must be defined and cannot be null.");
        else
            url_ += "description=" + encodeURIComponent("" + description) + "&"; 
        if (associationType === undefined || associationType === null)
            throw new Error("The parameter 'associationType' must be defined and cannot be null.");
        else
            url_ += "associationType=" + encodeURIComponent("" + associationType) + "&"; 
        if (associationId === undefined || associationId === null)
            throw new Error("The parameter 'associationId' must be defined and cannot be null.");
        else
            url_ += "associationId=" + encodeURIComponent("" + associationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (photoFile === null || photoFile === undefined)
            throw new Error("The parameter 'photoFile' cannot be null.");
        else
            content_.append("photoFile", photoFile.data, photoFile.fileName ? photoFile.fileName : "photoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadPhotoResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadPhotoResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadPhotoResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UploadPhotoResponseDto.fromJS(resultData200) : new UploadPhotoResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadPhotoResponseDto>(<any>null);
    }

    /**
     * @param photoFile Uploaded Photo
     * @param tag (optional) 
     * @return Success
     */
    uploadtagged(photoFile: FileParameter, description: string, associationType: string, associationId: string, tag: string | null | undefined): Observable<UploadPhotoResponseDto> {
        let url_ = this.baseUrl + "/photo/uploadtagged?";
        if (description === undefined || description === null)
            throw new Error("The parameter 'description' must be defined and cannot be null.");
        else
            url_ += "description=" + encodeURIComponent("" + description) + "&"; 
        if (associationType === undefined || associationType === null)
            throw new Error("The parameter 'associationType' must be defined and cannot be null.");
        else
            url_ += "associationType=" + encodeURIComponent("" + associationType) + "&"; 
        if (associationId === undefined || associationId === null)
            throw new Error("The parameter 'associationId' must be defined and cannot be null.");
        else
            url_ += "associationId=" + encodeURIComponent("" + associationId) + "&"; 
        if (tag !== undefined)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (photoFile === null || photoFile === undefined)
            throw new Error("The parameter 'photoFile' cannot be null.");
        else
            content_.append("photoFile", photoFile.data, photoFile.fileName ? photoFile.fileName : "photoFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadtagged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadtagged(<any>response_);
                } catch (e) {
                    return <Observable<UploadPhotoResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadPhotoResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadtagged(response: HttpResponseBase): Observable<UploadPhotoResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UploadPhotoResponseDto.fromJS(resultData200) : new UploadPhotoResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadPhotoResponseDto>(<any>null);
    }

    /**
     * @param vehicleId (optional) 
     * @return Success
     */
    getbyvehicleid(vehicleId: string | null | undefined): Observable<ListResultDtoOfGetPhotosResponseDto> {
        let url_ = this.baseUrl + "/photo/getbyvehicleid?";
        if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyvehicleid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyvehicleid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyvehicleid(response: HttpResponseBase): Observable<ListResultDtoOfGetPhotosResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPhotosResponseDto.fromJS(resultData200) : new ListResultDtoOfGetPhotosResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetPhotosResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param inspectionPointId (optional) 
     * @return Success
     */
    getbyInspectionIdAndInspectionPointId(inspectionId: string | null | undefined, inspectionPointId: string | null | undefined): Observable<ListResultDtoOfGetPhotosResponseDto> {
        let url_ = this.baseUrl + "/photo/getbyInspectionIdAndInspectionPointId?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (inspectionPointId !== undefined)
            url_ += "inspectionPointId=" + encodeURIComponent("" + inspectionPointId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyInspectionIdAndInspectionPointId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyInspectionIdAndInspectionPointId(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyInspectionIdAndInspectionPointId(response: HttpResponseBase): Observable<ListResultDtoOfGetPhotosResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPhotosResponseDto.fromJS(resultData200) : new ListResultDtoOfGetPhotosResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetPhotosResponseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletebyid(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/photo/deletebyid?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletebyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletebyid(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletebyid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param bodyShapeId (optional) 
     * @return Success
     */
    getbybodyshapeid(bodyShapeId: string | null | undefined): Observable<ListResultDtoOfGetPhotosResponseDto> {
        let url_ = this.baseUrl + "/photo/getbybodyshapeid?";
        if (bodyShapeId !== undefined)
            url_ += "bodyShapeId=" + encodeURIComponent("" + bodyShapeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbybodyshapeid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbybodyshapeid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbybodyshapeid(response: HttpResponseBase): Observable<ListResultDtoOfGetPhotosResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPhotosResponseDto.fromJS(resultData200) : new ListResultDtoOfGetPhotosResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetPhotosResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    getbyinspectionid(inspectionId: string | null | undefined): Observable<ListResultDtoOfGetPhotosResponseDto> {
        let url_ = this.baseUrl + "/photo/getbyinspectionid?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyinspectionid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyinspectionid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetPhotosResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyinspectionid(response: HttpResponseBase): Observable<ListResultDtoOfGetPhotosResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetPhotosResponseDto.fromJS(resultData200) : new ListResultDtoOfGetPhotosResponseDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetPhotosResponseDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param associationType (optional) 
     * @return Success
     */
    getbyinspectionidandassociationtype(inspectionId: string | null | undefined, associationType: string | null | undefined): Observable<ListResultDtoOfInspectionPointPhotoListDto> {
        let url_ = this.baseUrl + "/photo/getbyinspectionidandassociationtype?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (associationType !== undefined)
            url_ += "associationType=" + encodeURIComponent("" + associationType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetbyinspectionidandassociationtype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetbyinspectionidandassociationtype(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInspectionPointPhotoListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfInspectionPointPhotoListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetbyinspectionidandassociationtype(response: HttpResponseBase): Observable<ListResultDtoOfInspectionPointPhotoListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInspectionPointPhotoListDto.fromJS(resultData200) : new ListResultDtoOfInspectionPointPhotoListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfInspectionPointPhotoListDto>(<any>null);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param htmlFile Html File
     * @return Success
     */
    generatepdf(htmlFile: FileParameter, filename: string, engineType: string): Observable<void> {
        let url_ = this.baseUrl + "/report/generatepdf?";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined and cannot be null.");
        else
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        if (engineType === undefined || engineType === null)
            throw new Error("The parameter 'engineType' must be defined and cannot be null.");
        else
            url_ += "engineType=" + encodeURIComponent("" + engineType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (htmlFile === null || htmlFile === undefined)
            throw new Error("The parameter 'htmlFile' cannot be null.");
        else
            content_.append("htmlFile", htmlFile.data, htmlFile.fileName ? htmlFile.fileName : "htmlFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratepdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratepdf(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratepdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param htmlUrl (optional) 
     * @param filename (optional) 
     * @return Success
     */
    generatepdfviaheadlesschrome(htmlUrl: string | null | undefined, filename: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/generatepdfviaheadlesschrome?";
        if (htmlUrl !== undefined)
            url_ += "htmlUrl=" + encodeURIComponent("" + htmlUrl) + "&"; 
        if (filename !== undefined)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratepdfviaheadlesschrome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratepdfviaheadlesschrome(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratepdfviaheadlesschrome(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    generateinspection(inspectionId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/generateinspection?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateinspection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateinspection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateinspection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    getreportfilepath(inspectionId: string | null | undefined): Observable<ReportFileDto> {
        let url_ = this.baseUrl + "/report/getreportfilepath?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetreportfilepath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetreportfilepath(<any>response_);
                } catch (e) {
                    return <Observable<ReportFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetreportfilepath(response: HttpResponseBase): Observable<ReportFileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReportFileDto.fromJS(resultData200) : new ReportFileDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportFileDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param reportId (optional) 
     * @return Success
     */
    generateinspectionpoiintphotozipfile(inspectionId: string | null | undefined, reportId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/generateinspectionpoiintphotozipfile?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateinspectionpoiintphotozipfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateinspectionpoiintphotozipfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateinspectionpoiintphotozipfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    emailinspectiontoclient(inspectionId: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/report/emailinspectiontoclient?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailinspectiontoclient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailinspectiontoclient(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processEmailinspectiontoclient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    emailphotostoclient(inspectionId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/emailphotostoclient?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailphotostoclient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailphotostoclient(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEmailphotostoclient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getcommonoccurencelist(request: CommonIssueRequestDto | null | undefined): Observable<ListResultDtoOfCommonIssuesListDto> {
        let url_ = this.baseUrl + "/report/getcommonoccurencelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetcommonoccurencelist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetcommonoccurencelist(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCommonIssuesListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCommonIssuesListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetcommonoccurencelist(response: HttpResponseBase): Observable<ListResultDtoOfCommonIssuesListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCommonIssuesListDto.fromJS(resultData200) : new ListResultDtoOfCommonIssuesListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCommonIssuesListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getreportdata(input: ReportDataRequestDto | null | undefined): Observable<PagedResultDtoOfReportDataListDto> {
        let url_ = this.baseUrl + "/report/getreportdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetreportdata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetreportdata(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReportDataListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReportDataListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetreportdata(response: HttpResponseBase): Observable<PagedResultDtoOfReportDataListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfReportDataListDto.fromJS(resultData200) : new PagedResultDtoOfReportDataListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDataListDto>(<any>null);
    }

    /**
     * @param uri (optional) 
     * @return Success
     */
    delete(uri: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/delete?";
        if (uri !== undefined)
            url_ += "uri=" + encodeURIComponent("" + uri) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param commentIds (optional) 
     * @param inspectionId (optional) 
     * @return Success
     */
    sendreportcommentupdate(commentIds: string[] | null | undefined, inspectionId: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/report/sendreportcommentupdate?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendreportcommentupdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendreportcommentupdate(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processSendreportcommentupdate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendeod(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/report/sendeod?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendeod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendeod(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendeod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendeodscheduled(): Observable<void> {
        let url_ = this.baseUrl + "/report/sendeodscheduled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendeodscheduled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendeodscheduled(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendeodscheduled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRolesAsync?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfPermissionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPermissionDto.fromJS(resultData200) : new ListResultDtoOfPermissionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfPermissionDto>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getByName(name: string | null | undefined): Observable<Role> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetByName?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(<any>response_);
                } catch (e) {
                    return <Observable<Role>><any>_observableThrow(e);
                }
            } else
                return <Observable<Role>><any>_observableThrow(response_);
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<Role> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Role.fromJS(resultData200) : new Role();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Role>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param roleName (optional) 
     * @param displayName (optional) 
     * @param description (optional) 
     * @return Success
     */
    getAll(skipCount: number | null | undefined, maxResultCount: number | null | undefined, roleName: string | null | undefined, displayName: string | null | undefined, description: string | null | undefined): Observable<PagedResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (roleName !== undefined)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&"; 
        if (displayName !== undefined)
            url_ += "DisplayName=" + encodeURIComponent("" + displayName) + "&"; 
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRoleDto.fromJS(resultData200) : new PagedResultDtoOfRoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRoleDto>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class SplatdiagramServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    plotpoint(request: SplatDiagramPointRequestDto | null | undefined): Observable<SplatDiagramPointListDto> {
        let url_ = this.baseUrl + "/splatdiagram/plotpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlotpoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlotpoint(<any>response_);
                } catch (e) {
                    return <Observable<SplatDiagramPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SplatDiagramPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processPlotpoint(response: HttpResponseBase): Observable<SplatDiagramPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SplatDiagramPointListDto.fromJS(resultData200) : new SplatDiagramPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SplatDiagramPointListDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @return Success
     */
    listpoints(inspectionId: string | null | undefined): Observable<ListResultDtoOfSplatDiagramPointListDto> {
        let url_ = this.baseUrl + "/splatdiagram/listpoints?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListpoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListpoints(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSplatDiagramPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSplatDiagramPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListpoints(response: HttpResponseBase): Observable<ListResultDtoOfSplatDiagramPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSplatDiagramPointListDto.fromJS(resultData200) : new ListResultDtoOfSplatDiagramPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSplatDiagramPointListDto>(<any>null);
    }

    /**
     * @param inspectionId (optional) 
     * @param inspectionPointId (optional) 
     * @return Success
     */
    listpointsbyinspectionpointid(inspectionId: string | null | undefined, inspectionPointId: string | null | undefined): Observable<ListResultDtoOfSplatDiagramPointListDto> {
        let url_ = this.baseUrl + "/splatdiagram/listpointsbyinspectionpointid?";
        if (inspectionId !== undefined)
            url_ += "inspectionId=" + encodeURIComponent("" + inspectionId) + "&"; 
        if (inspectionPointId !== undefined)
            url_ += "inspectionPointId=" + encodeURIComponent("" + inspectionPointId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListpointsbyinspectionpointid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListpointsbyinspectionpointid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSplatDiagramPointListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSplatDiagramPointListDto>><any>_observableThrow(response_);
        }));
    }

    protected processListpointsbyinspectionpointid(response: HttpResponseBase): Observable<ListResultDtoOfSplatDiagramPointListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSplatDiagramPointListDto.fromJS(resultData200) : new ListResultDtoOfSplatDiagramPointListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSplatDiagramPointListDto>(<any>null);
    }

    /**
     * @param splatDiagramPointId (optional) 
     * @return Success
     */
    unplotpoint(splatDiagramPointId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/splatdiagram/unplotpoint?";
        if (splatDiagramPointId !== undefined)
            url_ += "splatDiagramPointId=" + encodeURIComponent("" + splatDiagramPointId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnplotpoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnplotpoint(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnplotpoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param tenancyName (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getAll(skipCount: number | null | undefined, maxResultCount: number | null | undefined, tenancyName: string | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined): Observable<PagedResultDtoOfTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (tenancyName !== undefined)
            url_ += "TenancyName=" + encodeURIComponent("" + tenancyName) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantDto.fromJS(resultData200) : new PagedResultDtoOfTenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class MigrateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param csvFile THL Data file
     * @return Success
     */
    thlfile(csvFile: FileParameter): Observable<void> {
        let url_ = this.baseUrl + "/migrate/thlfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csvFile === null || csvFile === undefined)
            throw new Error("The parameter 'csvFile' cannot be null.");
        else
            content_.append("csvFile", csvFile.data, csvFile.fileName ? csvFile.fileName : "csvFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processThlfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processThlfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processThlfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleDto.fromJS(resultData200) : new ListResultDtoOfRoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userName (optional) 
     * @param name (optional) 
     * @param isActive (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getAll(skipCount: number | null | undefined, maxResultCount: number | null | undefined, userName: string | null | undefined, name: string | null | undefined, isActive: boolean | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserDto.fromJS(resultData200) : new PagedResultDtoOfUserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(<any>null);
    }
}

@Injectable()
export class UseraccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param username (optional) 
     * @param oldPassword (optional) 
     * @param newPassword (optional) 
     * @param passwordResetCode (optional) 
     * @return Success
     */
    resetpassword(username: string | null | undefined, oldPassword: string | null | undefined, newPassword: string | null | undefined, passwordResetCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/useraccount/resetpassword?";
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (oldPassword !== undefined)
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&"; 
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&"; 
        if (passwordResetCode !== undefined)
            url_ += "passwordResetCode=" + encodeURIComponent("" + passwordResetCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetpassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetpassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetpassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    sendforgotpasswordemail(emailAddress: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/useraccount/sendforgotpasswordemail?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendforgotpasswordemail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendforgotpasswordemail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendforgotpasswordemail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    sendwelcomeemail(emailAddress: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/useraccount/sendwelcomeemail?";
        if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendwelcomeemail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendwelcomeemail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendwelcomeemail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param resetCode (optional) 
     * @return Success
     */
    detailsbypasswordresetcode(resetCode: string | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/useraccount/detailsbypasswordresetcode?";
        if (resetCode !== undefined)
            url_ += "resetCode=" + encodeURIComponent("" + resetCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetailsbypasswordresetcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetailsbypasswordresetcode(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processDetailsbypasswordresetcode(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param username (optional) 
     * @param newPassword (optional) 
     * @param passwordResetCode (optional) 
     * @return Success
     */
    createpassword(username: string | null | undefined, newPassword: string | null | undefined, passwordResetCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/useraccount/createpassword?";
        if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&"; 
        if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&"; 
        if (passwordResetCode !== undefined)
            url_ += "passwordResetCode=" + encodeURIComponent("" + passwordResetCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatepassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatepassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatepassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VehiclesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getallmakes(): Observable<ListResultDtoOfVehicleMakeModelListDto> {
        let url_ = this.baseUrl + "/vehicles/getallmakes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetallmakes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetallmakes(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVehicleMakeModelListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfVehicleMakeModelListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetallmakes(response: HttpResponseBase): Observable<ListResultDtoOfVehicleMakeModelListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVehicleMakeModelListDto.fromJS(resultData200) : new ListResultDtoOfVehicleMakeModelListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfVehicleMakeModelListDto>(<any>null);
    }

    /**
     * @param makeId (optional) 
     * @return Success
     */
    getmodelsbymakeid(makeId: string | null | undefined): Observable<ListResultDtoOfVehicleModelListDto> {
        let url_ = this.baseUrl + "/vehicles/getmodelsbymakeid?";
        if (makeId !== undefined)
            url_ += "makeId=" + encodeURIComponent("" + makeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetmodelsbymakeid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetmodelsbymakeid(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVehicleModelListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfVehicleModelListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetmodelsbymakeid(response: HttpResponseBase): Observable<ListResultDtoOfVehicleModelListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVehicleModelListDto.fromJS(resultData200) : new ListResultDtoOfVehicleModelListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfVehicleModelListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getdetailsbyid(id: string | null | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles/getdetailsbyid?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetdetailsbyid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetdetailsbyid(<any>response_);
                } catch (e) {
                    return <Observable<VehicleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetdetailsbyid(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleDto.fromJS(resultData200) : new VehicleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    create(request: CreateVehicleRequestDto | null | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VehicleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleDto.fromJS(resultData200) : new VehicleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    update(request: UpdateVehicleRequestDto | null | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/vehicles/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VehicleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleDto.fromJS(resultData200) : new VehicleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    search(request: VehicleInspectionVersionSearchRequestDto | null | undefined): Observable<ListResultDtoOfVehicleInspectionVersionListDto> {
        let url_ = this.baseUrl + "/vehicles/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfVehicleInspectionVersionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfVehicleInspectionVersionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ListResultDtoOfVehicleInspectionVersionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfVehicleInspectionVersionListDto.fromJS(resultData200) : new ListResultDtoOfVehicleInspectionVersionListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfVehicleInspectionVersionListDto>(<any>null);
    }
}

@Injectable()
export class VehicleModelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateVehicleModelDto | null | undefined): Observable<VehicleModelDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleModel/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<VehicleModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleModelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleModelDto.fromJS(resultData200) : new VehicleModelDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModelDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: VehicleModelDto | null | undefined): Observable<VehicleModelDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleModel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<VehicleModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleModelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleModelDto.fromJS(resultData200) : new VehicleModelDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModelDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<VehicleModelDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleModel/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<VehicleModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleModelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? VehicleModelDto.fromJS(resultData200) : new VehicleModelDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleModelDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleModel/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param makeName (optional) 
     * @param modelName (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getAll(skipCount: number | null | undefined, maxResultCount: number | null | undefined, makeName: string | null | undefined, modelName: string | null | undefined, isActive: boolean | null | undefined): Observable<PagedResultDtoOfVehicleModelDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleModel/GetAll?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (makeName !== undefined)
            url_ += "MakeName=" + encodeURIComponent("" + makeName) + "&"; 
        if (modelName !== undefined)
            url_ += "ModelName=" + encodeURIComponent("" + modelName) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVehicleModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVehicleModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfVehicleModelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfVehicleModelDto.fromJS(resultData200) : new PagedResultDtoOfVehicleModelDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVehicleModelDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class ListResultDtoOfDateTime implements IListResultDtoOfDateTime {
    items: moment.Moment[] | undefined;

    constructor(data?: IListResultDtoOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(moment(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toISOString());
        }
        return data; 
    }

    clone(): ListResultDtoOfDateTime {
        const json = this.toJSON();
        let result = new ListResultDtoOfDateTime();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfDateTime {
    items: moment.Moment[] | undefined;
}

export class CreateBranchDto implements ICreateBranchDto {
    displayName: string;
    primaryEmail: string;
    primaryPhone: string | undefined;
    secondaryEmail: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    externalId: number | undefined;
    country: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: ICreateBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.primaryEmail = data["primaryEmail"];
            this.primaryPhone = data["primaryPhone"];
            this.secondaryEmail = data["secondaryEmail"];
            this.secondaryPhone = data["secondaryPhone"];
            this.address = data["address"];
            this.externalId = data["externalId"];
            this.country = data["country"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["primaryEmail"] = this.primaryEmail;
        data["primaryPhone"] = this.primaryPhone;
        data["secondaryEmail"] = this.secondaryEmail;
        data["secondaryPhone"] = this.secondaryPhone;
        data["address"] = this.address;
        data["externalId"] = this.externalId;
        data["country"] = this.country;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateBranchDto {
        const json = this.toJSON();
        let result = new CreateBranchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBranchDto {
    displayName: string;
    primaryEmail: string;
    primaryPhone: string | undefined;
    secondaryEmail: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    externalId: number | undefined;
    country: string | undefined;
    isActive: boolean | undefined;
}

export class BranchDto implements IBranchDto {
    displayName: string;
    primaryEmail: string;
    primaryPhone: string | undefined;
    secondaryEmail: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    externalId: number | undefined;
    country: string | undefined;
    isActive: boolean | undefined;
    id: string | undefined;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.primaryEmail = data["primaryEmail"];
            this.primaryPhone = data["primaryPhone"];
            this.secondaryEmail = data["secondaryEmail"];
            this.secondaryPhone = data["secondaryPhone"];
            this.address = data["address"];
            this.externalId = data["externalId"];
            this.country = data["country"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["primaryEmail"] = this.primaryEmail;
        data["primaryPhone"] = this.primaryPhone;
        data["secondaryEmail"] = this.secondaryEmail;
        data["secondaryPhone"] = this.secondaryPhone;
        data["address"] = this.address;
        data["externalId"] = this.externalId;
        data["country"] = this.country;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): BranchDto {
        const json = this.toJSON();
        let result = new BranchDto();
        result.init(json);
        return result;
    }
}

export interface IBranchDto {
    displayName: string;
    primaryEmail: string;
    primaryPhone: string | undefined;
    secondaryEmail: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    externalId: number | undefined;
    country: string | undefined;
    isActive: boolean | undefined;
    id: string | undefined;
}

export class ListResultDtoOfBranchDto implements IListResultDtoOfBranchDto {
    items: BranchDto[] | undefined;

    constructor(data?: IListResultDtoOfBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfBranchDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfBranchDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfBranchDto {
    items: BranchDto[] | undefined;
}

export class ListResultDtoOfCountryCodeDto implements IListResultDtoOfCountryCodeDto {
    items: CountryCodeDto[] | undefined;

    constructor(data?: IListResultDtoOfCountryCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CountryCodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCountryCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCountryCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCountryCodeDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCountryCodeDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCountryCodeDto {
    items: CountryCodeDto[] | undefined;
}

export class CountryCodeDto implements ICountryCodeDto {
    countryCode: string | undefined;

    constructor(data?: ICountryCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
        }
    }

    static fromJS(data: any): CountryCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): CountryCodeDto {
        const json = this.toJSON();
        let result = new CountryCodeDto();
        result.init(json);
        return result;
    }
}

export interface ICountryCodeDto {
    countryCode: string | undefined;
}

export class PagedResultDtoOfBranchDto implements IPagedResultDtoOfBranchDto {
    totalCount: number | undefined;
    items: BranchDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BranchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfBranchDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBranchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBranchDto {
    totalCount: number | undefined;
    items: BranchDto[] | undefined;
}

export class ListResultDtoOfCommentThreadDto implements IListResultDtoOfCommentThreadDto {
    items: CommentThreadDto[] | undefined;

    constructor(data?: IListResultDtoOfCommentThreadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CommentThreadDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCommentThreadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCommentThreadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCommentThreadDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCommentThreadDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCommentThreadDto {
    items: CommentThreadDto[] | undefined;
}

export class CommentThreadDto implements ICommentThreadDto {
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;
    inspectionPointCategoryName: string | undefined;
    inspectionPointName: string | undefined;
    comments: Comments[] | undefined;

    constructor(data?: ICommentThreadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionId = data["inspectionId"];
            this.inspectionPointId = data["inspectionPointId"];
            this.inspectionPointCategoryName = data["inspectionPointCategoryName"];
            this.inspectionPointName = data["inspectionPointName"];
            if (data["comments"] && data["comments"].constructor === Array) {
                this.comments = [] as any;
                for (let item of data["comments"])
                    this.comments.push(Comments.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentThreadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentThreadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["inspectionPointId"] = this.inspectionPointId;
        data["inspectionPointCategoryName"] = this.inspectionPointCategoryName;
        data["inspectionPointName"] = this.inspectionPointName;
        if (this.comments && this.comments.constructor === Array) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CommentThreadDto {
        const json = this.toJSON();
        let result = new CommentThreadDto();
        result.init(json);
        return result;
    }
}

export interface ICommentThreadDto {
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;
    inspectionPointCategoryName: string | undefined;
    inspectionPointName: string | undefined;
    comments: Comments[] | undefined;
}

export class Comments implements IComments {
    message: string | undefined;
    succeedingCommentId: string | undefined;
    inspectorName: string | undefined;
    succeedingComment: Comments | undefined;
    user: User | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IComments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.succeedingCommentId = data["succeedingCommentId"];
            this.inspectorName = data["inspectorName"];
            this.succeedingComment = data["succeedingComment"] ? Comments.fromJS(data["succeedingComment"]) : <any>undefined;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Comments {
        data = typeof data === 'object' ? data : {};
        let result = new Comments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["succeedingCommentId"] = this.succeedingCommentId;
        data["inspectorName"] = this.inspectorName;
        data["succeedingComment"] = this.succeedingComment ? this.succeedingComment.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Comments {
        const json = this.toJSON();
        let result = new Comments();
        result.init(json);
        return result;
    }
}

export interface IComments {
    message: string | undefined;
    succeedingCommentId: string | undefined;
    inspectorName: string | undefined;
    succeedingComment: Comments | undefined;
    user: User | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class User implements IUser {
    passwordResetCodeExpiryUtc: moment.Moment | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User | undefined;
    creatorUser: User | undefined;
    lastModifierUser: User | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number | undefined;
    isLockoutEnabled: boolean | undefined;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean | undefined;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean | undefined;
    isActive: boolean | undefined;
    lastLoginTime: moment.Moment | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.passwordResetCodeExpiryUtc = data["passwordResetCodeExpiryUtc"] ? moment(data["passwordResetCodeExpiryUtc"].toString()) : <any>undefined;
            this.accessType = data["accessType"];
            this.branchId = data["branchId"];
            this.countryCode = data["countryCode"];
            this.normalizedUserName = data["normalizedUserName"];
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.concurrencyStamp = data["concurrencyStamp"];
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [] as any;
                for (let item of data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = data["authenticationSource"];
            this.userName = data["userName"];
            this.tenantId = data["tenantId"];
            this.emailAddress = data["emailAddress"];
            this.name = data["name"];
            this.surname = data["surname"];
            (<any>this).fullName = data["fullName"];
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.passwordResetCode = data["passwordResetCode"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = data["accessFailedCount"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.securityStamp = data["securityStamp"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            if (data["logins"] && data["logins"].constructor === Array) {
                this.logins = [] as any;
                for (let item of data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [] as any;
                for (let item of data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (data["settings"] && data["settings"].constructor === Array) {
                this.settings = [] as any;
                for (let item of data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordResetCodeExpiryUtc"] = this.passwordResetCodeExpiryUtc ? this.passwordResetCodeExpiryUtc.toISOString() : <any>undefined;
        data["accessType"] = this.accessType;
        data["branchId"] = this.branchId;
        data["countryCode"] = this.countryCode;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (this.logins && this.logins.constructor === Array) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.settings && this.settings.constructor === Array) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    passwordResetCodeExpiryUtc: moment.Moment | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User | undefined;
    creatorUser: User | undefined;
    lastModifierUser: User | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number | undefined;
    isLockoutEnabled: boolean | undefined;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean | undefined;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean | undefined;
    isActive: boolean | undefined;
    lastLoginTime: moment.Moment | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UserToken implements IUserToken {
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.value = data["value"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number | undefined;
}

export class UserLogin implements IUserLogin {
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string;
    providerKey: string;
    id: number | undefined;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number | undefined;
    loginProvider: string;
    providerKey: string;
    id: number | undefined;
}

export class UserRole implements IUserRole {
    tenantId: number | undefined;
    userId: number | undefined;
    roleId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.roleId = data["roleId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number | undefined;
    roleId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UserClaim implements IUserClaim {
    tenantId: number | undefined;
    userId: number | undefined;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number | undefined;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    userId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class Setting implements ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCommentsListDto implements IListResultDtoOfCommentsListDto {
    items: CommentsListDto[] | undefined;

    constructor(data?: IListResultDtoOfCommentsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CommentsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCommentsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCommentsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCommentsListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCommentsListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCommentsListDto {
    items: CommentsListDto[] | undefined;
}

export class CommentsListDto implements ICommentsListDto {
    id: string | undefined;
    message: string | undefined;
    succeedingCommentId: string | undefined;

    constructor(data?: ICommentsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
            this.succeedingCommentId = data["succeedingCommentId"];
        }
    }

    static fromJS(data: any): CommentsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["succeedingCommentId"] = this.succeedingCommentId;
        return data; 
    }

    clone(): CommentsListDto {
        const json = this.toJSON();
        let result = new CommentsListDto();
        result.init(json);
        return result;
    }
}

export interface ICommentsListDto {
    id: string | undefined;
    message: string | undefined;
    succeedingCommentId: string | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.theme = data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class TenantBrandingInput implements ITenantBrandingInput {
    customBaseColor: string | undefined;
    logoImagePath: string | undefined;

    constructor(data?: ITenantBrandingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customBaseColor = data["customBaseColor"];
            this.logoImagePath = data["logoImagePath"];
        }
    }

    static fromJS(data: any): TenantBrandingInput {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBrandingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customBaseColor"] = this.customBaseColor;
        data["logoImagePath"] = this.logoImagePath;
        return data; 
    }

    clone(): TenantBrandingInput {
        const json = this.toJSON();
        let result = new TenantBrandingInput();
        result.init(json);
        return result;
    }
}

export interface ITenantBrandingInput {
    customBaseColor: string | undefined;
    logoImagePath: string | undefined;
}

export class UploadLogoResponseDto implements IUploadLogoResponseDto {
    path: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IUploadLogoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UploadLogoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLogoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UploadLogoResponseDto {
        const json = this.toJSON();
        let result = new UploadLogoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUploadLogoResponseDto {
    path: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class CustomerDto implements ICustomerDto {
    id: string | undefined;
    displayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    street: string | undefined;
    unitNumber: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    region: string | undefined;
    countryCode: string | undefined;
    suburb: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.companyName = data["companyName"];
            this.type = data["type"];
            this.primaryEmail = data["primaryEmail"];
            this.secondaryEmail = data["secondaryEmail"];
            this.primaryPhone = data["primaryPhone"];
            this.secondaryPhone = data["secondaryPhone"];
            this.address = data["address"];
            this.street = data["street"];
            this.unitNumber = data["unitNumber"];
            this.city = data["city"];
            this.zipCode = data["zipCode"];
            this.region = data["region"];
            this.countryCode = data["countryCode"];
            this.suburb = data["suburb"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["type"] = this.type;
        data["primaryEmail"] = this.primaryEmail;
        data["secondaryEmail"] = this.secondaryEmail;
        data["primaryPhone"] = this.primaryPhone;
        data["secondaryPhone"] = this.secondaryPhone;
        data["address"] = this.address;
        data["street"] = this.street;
        data["unitNumber"] = this.unitNumber;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["region"] = this.region;
        data["countryCode"] = this.countryCode;
        data["suburb"] = this.suburb;
        return data; 
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    id: string | undefined;
    displayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
    street: string | undefined;
    unitNumber: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    region: string | undefined;
    countryCode: string | undefined;
    suburb: string | undefined;
}

export class CustomerSearchRequestDto implements ICustomerSearchRequestDto {
    searchString: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: ICustomerSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchString = data["searchString"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): CustomerSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): CustomerSearchRequestDto {
        const json = this.toJSON();
        let result = new CustomerSearchRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerSearchRequestDto {
    searchString: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ListResultDtoOfCustomerDto implements IListResultDtoOfCustomerDto {
    items: CustomerDto[] | undefined;

    constructor(data?: IListResultDtoOfCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCustomerDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCustomerDto {
    items: CustomerDto[] | undefined;
}

export class CreateEmailNotificationDto implements ICreateEmailNotificationDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;

    constructor(data?: ICreateEmailNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
            this.emailAddress = data["emailAddress"];
            this.reportIds = data["reportIds"];
            this.branchIds = data["branchIds"];
            this.branchExclusionIds = data["branchExclusionIds"];
        }
    }

    static fromJS(data: any): CreateEmailNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["emailAddress"] = this.emailAddress;
        data["reportIds"] = this.reportIds;
        data["branchIds"] = this.branchIds;
        data["branchExclusionIds"] = this.branchExclusionIds;
        return data; 
    }

    clone(): CreateEmailNotificationDto {
        const json = this.toJSON();
        let result = new CreateEmailNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmailNotificationDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;
}

export class EmailNotificationDto implements IEmailNotificationDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;
    id: string | undefined;

    constructor(data?: IEmailNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
            this.emailAddress = data["emailAddress"];
            this.reportIds = data["reportIds"];
            this.branchIds = data["branchIds"];
            this.branchExclusionIds = data["branchExclusionIds"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EmailNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["emailAddress"] = this.emailAddress;
        data["reportIds"] = this.reportIds;
        data["branchIds"] = this.branchIds;
        data["branchExclusionIds"] = this.branchExclusionIds;
        data["id"] = this.id;
        return data; 
    }

    clone(): EmailNotificationDto {
        const json = this.toJSON();
        let result = new EmailNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IEmailNotificationDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;
    id: string | undefined;
}

export class PagedEmailNotificationResultRequestDto implements IPagedEmailNotificationResultRequestDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IPagedEmailNotificationResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryCode = data["countryCode"];
            this.emailAddress = data["emailAddress"];
            this.reportIds = data["reportIds"];
            this.branchIds = data["branchIds"];
            this.branchExclusionIds = data["branchExclusionIds"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): PagedEmailNotificationResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedEmailNotificationResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["emailAddress"] = this.emailAddress;
        data["reportIds"] = this.reportIds;
        data["branchIds"] = this.branchIds;
        data["branchExclusionIds"] = this.branchExclusionIds;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): PagedEmailNotificationResultRequestDto {
        const json = this.toJSON();
        let result = new PagedEmailNotificationResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedEmailNotificationResultRequestDto {
    countryCode: string | undefined;
    emailAddress: string | undefined;
    reportIds: string | undefined;
    branchIds: string | undefined;
    branchExclusionIds: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ListResultDtoOfEmailNotificationDto implements IListResultDtoOfEmailNotificationDto {
    items: EmailNotificationDto[] | undefined;

    constructor(data?: IListResultDtoOfEmailNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(EmailNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEmailNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEmailNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfEmailNotificationDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfEmailNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfEmailNotificationDto {
    items: EmailNotificationDto[] | undefined;
}

export class ListResultDtoOfIconListDto implements IListResultDtoOfIconListDto {
    items: IconListDto[] | undefined;

    constructor(data?: IListResultDtoOfIconListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(IconListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIconListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfIconListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfIconListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfIconListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfIconListDto {
    items: IconListDto[] | undefined;
}

export class IconListDto implements IIconListDto {
    id: string | undefined;
    photoId: string | undefined;
    photoAssocId: string | undefined;
    imagePath: string | undefined;
    description: string | undefined;

    constructor(data?: IIconListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.photoId = data["photoId"];
            this.photoAssocId = data["photoAssocId"];
            this.imagePath = data["imagePath"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): IconListDto {
        data = typeof data === 'object' ? data : {};
        let result = new IconListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["photoId"] = this.photoId;
        data["photoAssocId"] = this.photoAssocId;
        data["imagePath"] = this.imagePath;
        data["description"] = this.description;
        return data; 
    }

    clone(): IconListDto {
        const json = this.toJSON();
        let result = new IconListDto();
        result.init(json);
        return result;
    }
}

export interface IIconListDto {
    id: string | undefined;
    photoId: string | undefined;
    photoAssocId: string | undefined;
    imagePath: string | undefined;
    description: string | undefined;
}

export class InspectionUpdateRequestDto implements IInspectionUpdateRequestDto {
    id: string | undefined;
    inspectionStatusId: string | undefined;
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectorId: number | undefined;

    constructor(data?: IInspectionUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.inspectionStatusId = data["inspectionStatusId"];
            this.vehicleId = data["vehicleId"];
            this.customerId = data["customerId"];
            this.branchId = data["branchId"];
            this.inspectionTypeId = data["inspectionTypeId"];
            this.inspectorId = data["inspectorId"];
        }
    }

    static fromJS(data: any): InspectionUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["vehicleId"] = this.vehicleId;
        data["customerId"] = this.customerId;
        data["branchId"] = this.branchId;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["inspectorId"] = this.inspectorId;
        return data; 
    }

    clone(): InspectionUpdateRequestDto {
        const json = this.toJSON();
        let result = new InspectionUpdateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionUpdateRequestDto {
    id: string | undefined;
    inspectionStatusId: string | undefined;
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectorId: number | undefined;
}

export class InspectionListResponseDto implements IInspectionListResponseDto {
    inspectionStatusId: string | undefined;
    inspectorId: number | undefined;
    reportId: number | undefined;
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectors: string[] | undefined;
    inspectorName: string | undefined;
    inspectionDetailsDefinition: any | undefined;
    inspectionStatus: LookupNameDto | undefined;
    vehicle: Vehicles | undefined;
    customer: CustomerListDto | undefined;
    branch: TenantBranchListDto | undefined;
    photos: PhotoListDto[] | undefined;
    inspectionPhotos: SimplePhoto[] | undefined;
    inspectionType: LK_InspectionTypeListDto | undefined;
    pdfEmailCounter: number | undefined;
    commentEmailCounter: number | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IInspectionListResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionStatusId = data["inspectionStatusId"];
            this.inspectorId = data["inspectorId"];
            this.reportId = data["reportId"];
            this.vehicleId = data["vehicleId"];
            this.customerId = data["customerId"];
            this.branchId = data["branchId"];
            this.inspectionTypeId = data["inspectionTypeId"];
            if (data["inspectors"] && data["inspectors"].constructor === Array) {
                this.inspectors = [] as any;
                for (let item of data["inspectors"])
                    this.inspectors.push(item);
            }
            this.inspectorName = data["inspectorName"];
            this.inspectionDetailsDefinition = data["inspectionDetailsDefinition"];
            this.inspectionStatus = data["inspectionStatus"] ? LookupNameDto.fromJS(data["inspectionStatus"]) : <any>undefined;
            this.vehicle = data["vehicle"] ? Vehicles.fromJS(data["vehicle"]) : <any>undefined;
            this.customer = data["customer"] ? CustomerListDto.fromJS(data["customer"]) : <any>undefined;
            this.branch = data["branch"] ? TenantBranchListDto.fromJS(data["branch"]) : <any>undefined;
            if (data["photos"] && data["photos"].constructor === Array) {
                this.photos = [] as any;
                for (let item of data["photos"])
                    this.photos.push(PhotoListDto.fromJS(item));
            }
            if (data["inspectionPhotos"] && data["inspectionPhotos"].constructor === Array) {
                this.inspectionPhotos = [] as any;
                for (let item of data["inspectionPhotos"])
                    this.inspectionPhotos.push(SimplePhoto.fromJS(item));
            }
            this.inspectionType = data["inspectionType"] ? LK_InspectionTypeListDto.fromJS(data["inspectionType"]) : <any>undefined;
            this.pdfEmailCounter = data["pdfEmailCounter"];
            this.commentEmailCounter = data["commentEmailCounter"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InspectionListResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionListResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["inspectorId"] = this.inspectorId;
        data["reportId"] = this.reportId;
        data["vehicleId"] = this.vehicleId;
        data["customerId"] = this.customerId;
        data["branchId"] = this.branchId;
        data["inspectionTypeId"] = this.inspectionTypeId;
        if (this.inspectors && this.inspectors.constructor === Array) {
            data["inspectors"] = [];
            for (let item of this.inspectors)
                data["inspectors"].push(item);
        }
        data["inspectorName"] = this.inspectorName;
        data["inspectionDetailsDefinition"] = this.inspectionDetailsDefinition;
        data["inspectionStatus"] = this.inspectionStatus ? this.inspectionStatus.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        if (this.photos && this.photos.constructor === Array) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item.toJSON());
        }
        if (this.inspectionPhotos && this.inspectionPhotos.constructor === Array) {
            data["inspectionPhotos"] = [];
            for (let item of this.inspectionPhotos)
                data["inspectionPhotos"].push(item.toJSON());
        }
        data["inspectionType"] = this.inspectionType ? this.inspectionType.toJSON() : <any>undefined;
        data["pdfEmailCounter"] = this.pdfEmailCounter;
        data["commentEmailCounter"] = this.commentEmailCounter;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InspectionListResponseDto {
        const json = this.toJSON();
        let result = new InspectionListResponseDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionListResponseDto {
    inspectionStatusId: string | undefined;
    inspectorId: number | undefined;
    reportId: number | undefined;
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectors: string[] | undefined;
    inspectorName: string | undefined;
    inspectionDetailsDefinition: any | undefined;
    inspectionStatus: LookupNameDto | undefined;
    vehicle: Vehicles | undefined;
    customer: CustomerListDto | undefined;
    branch: TenantBranchListDto | undefined;
    photos: PhotoListDto[] | undefined;
    inspectionPhotos: SimplePhoto[] | undefined;
    inspectionType: LK_InspectionTypeListDto | undefined;
    pdfEmailCounter: number | undefined;
    commentEmailCounter: number | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class LookupNameDto implements ILookupNameDto {
    name: string | undefined;
    displayName: string | undefined;

    constructor(data?: ILookupNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): LookupNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data; 
    }

    clone(): LookupNameDto {
        const json = this.toJSON();
        let result = new LookupNameDto();
        result.init(json);
        return result;
    }
}

export interface ILookupNameDto {
    name: string | undefined;
    displayName: string | undefined;
}

export class Vehicles implements IVehicles {
    customerId: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: VehicleStatus | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IVehicles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.stockNumber = data["stockNumber"];
            this.vinNumber = data["vinNumber"];
            this.registrationNumber = data["registrationNumber"];
            this.vehicleStatus = data["vehicleStatus"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Vehicles {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["stockNumber"] = this.stockNumber;
        data["vinNumber"] = this.vinNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["vehicleStatus"] = this.vehicleStatus;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Vehicles {
        const json = this.toJSON();
        let result = new Vehicles();
        result.init(json);
        return result;
    }
}

export interface IVehicles {
    customerId: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: VehicleStatus | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class CustomerListDto implements ICustomerListDto {
    id: string | undefined;
    displayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    address: string | undefined;
    secondaryPhone: string | undefined;
    street: string | undefined;
    unitNumber: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    region: string | undefined;
    countryCode: string | undefined;
    suburb: string | undefined;

    constructor(data?: ICustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.companyName = data["companyName"];
            this.type = data["type"];
            this.primaryEmail = data["primaryEmail"];
            this.secondaryEmail = data["secondaryEmail"];
            this.primaryPhone = data["primaryPhone"];
            this.address = data["address"];
            this.secondaryPhone = data["secondaryPhone"];
            this.street = data["street"];
            this.unitNumber = data["unitNumber"];
            this.city = data["city"];
            this.zipCode = data["zipCode"];
            this.region = data["region"];
            this.countryCode = data["countryCode"];
            this.suburb = data["suburb"];
        }
    }

    static fromJS(data: any): CustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["type"] = this.type;
        data["primaryEmail"] = this.primaryEmail;
        data["secondaryEmail"] = this.secondaryEmail;
        data["primaryPhone"] = this.primaryPhone;
        data["address"] = this.address;
        data["secondaryPhone"] = this.secondaryPhone;
        data["street"] = this.street;
        data["unitNumber"] = this.unitNumber;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["region"] = this.region;
        data["countryCode"] = this.countryCode;
        data["suburb"] = this.suburb;
        return data; 
    }

    clone(): CustomerListDto {
        const json = this.toJSON();
        let result = new CustomerListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerListDto {
    id: string | undefined;
    displayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    address: string | undefined;
    secondaryPhone: string | undefined;
    street: string | undefined;
    unitNumber: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    region: string | undefined;
    countryCode: string | undefined;
    suburb: string | undefined;
}

export class TenantBranchListDto implements ITenantBranchListDto {
    displayName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;

    constructor(data?: ITenantBranchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.type = data["type"];
            this.primaryEmail = data["primaryEmail"];
            this.secondaryEmail = data["secondaryEmail"];
            this.primaryPhone = data["primaryPhone"];
            this.secondaryPhone = data["secondaryPhone"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): TenantBranchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBranchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["primaryEmail"] = this.primaryEmail;
        data["secondaryEmail"] = this.secondaryEmail;
        data["primaryPhone"] = this.primaryPhone;
        data["secondaryPhone"] = this.secondaryPhone;
        data["address"] = this.address;
        return data; 
    }

    clone(): TenantBranchListDto {
        const json = this.toJSON();
        let result = new TenantBranchListDto();
        result.init(json);
        return result;
    }
}

export interface ITenantBranchListDto {
    displayName: string | undefined;
    type: string | undefined;
    primaryEmail: string | undefined;
    secondaryEmail: string | undefined;
    primaryPhone: string | undefined;
    secondaryPhone: string | undefined;
    address: string | undefined;
}

export class PhotoListDto implements IPhotoListDto {
    path: string | undefined;
    description: string | undefined;

    constructor(data?: IPhotoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): PhotoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["description"] = this.description;
        return data; 
    }

    clone(): PhotoListDto {
        const json = this.toJSON();
        let result = new PhotoListDto();
        result.init(json);
        return result;
    }
}

export interface IPhotoListDto {
    path: string | undefined;
    description: string | undefined;
}

export class SimplePhoto implements ISimplePhoto {
    path: string | undefined;
    description: string | undefined;
    inspectionPointId: string | undefined;

    constructor(data?: ISimplePhoto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.description = data["description"];
            this.inspectionPointId = data["inspectionPointId"];
        }
    }

    static fromJS(data: any): SimplePhoto {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePhoto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["description"] = this.description;
        data["inspectionPointId"] = this.inspectionPointId;
        return data; 
    }

    clone(): SimplePhoto {
        const json = this.toJSON();
        let result = new SimplePhoto();
        result.init(json);
        return result;
    }
}

export interface ISimplePhoto {
    path: string | undefined;
    description: string | undefined;
    inspectionPointId: string | undefined;
}

export class LK_InspectionTypeListDto implements ILK_InspectionTypeListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    templateHTML: string | undefined;

    constructor(data?: ILK_InspectionTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.templateHTML = data["templateHTML"];
        }
    }

    static fromJS(data: any): LK_InspectionTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LK_InspectionTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["templateHTML"] = this.templateHTML;
        return data; 
    }

    clone(): LK_InspectionTypeListDto {
        const json = this.toJSON();
        let result = new LK_InspectionTypeListDto();
        result.init(json);
        return result;
    }
}

export interface ILK_InspectionTypeListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    templateHTML: string | undefined;
}

export class InspectionCreateRequestDto implements IInspectionCreateRequestDto {
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectorId: number | undefined;

    constructor(data?: IInspectionCreateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vehicleId = data["vehicleId"];
            this.customerId = data["customerId"];
            this.branchId = data["branchId"];
            this.inspectionTypeId = data["inspectionTypeId"];
            this.inspectorId = data["inspectorId"];
        }
    }

    static fromJS(data: any): InspectionCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionCreateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["customerId"] = this.customerId;
        data["branchId"] = this.branchId;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["inspectorId"] = this.inspectorId;
        return data; 
    }

    clone(): InspectionCreateRequestDto {
        const json = this.toJSON();
        let result = new InspectionCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionCreateRequestDto {
    vehicleId: string | undefined;
    customerId: string | undefined;
    branchId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectorId: number | undefined;
}

export class ListResultDtoOfBookingListDto implements IListResultDtoOfBookingListDto {
    items: BookingListDto[] | undefined;

    constructor(data?: IListResultDtoOfBookingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BookingListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBookingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfBookingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfBookingListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfBookingListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfBookingListDto {
    items: BookingListDto[] | undefined;
}

export class BookingListDto implements IBookingListDto {
    externalIdentifier: string | undefined;
    thirdPartyName: string | undefined;
    bookingTime: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    customerEmail: string | undefined;
    companyName: string | undefined;
    businessCustomerCode: string | undefined;
    regoOrLast6DigitVIN: string | undefined;
    vehicleMake: string | undefined;
    vehicleModel: string | undefined;
    colour: string | undefined;
    hasCurrentWofAndRego: boolean | undefined;
    canBeDisclosedToAnyone: boolean | undefined;
    reportEmailDelivery: boolean | undefined;
    reportHardCopyDelivery: boolean | undefined;
    buyingOrSelling: boolean | undefined;
    additionalComments: string | undefined;
    bookingStatus: string | undefined;
    inspectionId: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IBookingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.externalIdentifier = data["externalIdentifier"];
            this.thirdPartyName = data["thirdPartyName"];
            this.bookingTime = data["bookingTime"] ? moment(data["bookingTime"].toString()) : <any>undefined;
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.customerName = data["customerName"];
            this.customerPhoneNumber = data["customerPhoneNumber"];
            this.customerEmail = data["customerEmail"];
            this.companyName = data["companyName"];
            this.businessCustomerCode = data["businessCustomerCode"];
            this.regoOrLast6DigitVIN = data["regoOrLast6DigitVIN"];
            this.vehicleMake = data["vehicleMake"];
            this.vehicleModel = data["vehicleModel"];
            this.colour = data["colour"];
            this.hasCurrentWofAndRego = data["hasCurrentWofAndRego"];
            this.canBeDisclosedToAnyone = data["canBeDisclosedToAnyone"];
            this.reportEmailDelivery = data["reportEmailDelivery"];
            this.reportHardCopyDelivery = data["reportHardCopyDelivery"];
            this.buyingOrSelling = data["buyingOrSelling"];
            this.additionalComments = data["additionalComments"];
            this.bookingStatus = data["bookingStatus"];
            this.inspectionId = data["inspectionId"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BookingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIdentifier"] = this.externalIdentifier;
        data["thirdPartyName"] = this.thirdPartyName;
        data["bookingTime"] = this.bookingTime ? this.bookingTime.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["customerEmail"] = this.customerEmail;
        data["companyName"] = this.companyName;
        data["businessCustomerCode"] = this.businessCustomerCode;
        data["regoOrLast6DigitVIN"] = this.regoOrLast6DigitVIN;
        data["vehicleMake"] = this.vehicleMake;
        data["vehicleModel"] = this.vehicleModel;
        data["colour"] = this.colour;
        data["hasCurrentWofAndRego"] = this.hasCurrentWofAndRego;
        data["canBeDisclosedToAnyone"] = this.canBeDisclosedToAnyone;
        data["reportEmailDelivery"] = this.reportEmailDelivery;
        data["reportHardCopyDelivery"] = this.reportHardCopyDelivery;
        data["buyingOrSelling"] = this.buyingOrSelling;
        data["additionalComments"] = this.additionalComments;
        data["bookingStatus"] = this.bookingStatus;
        data["inspectionId"] = this.inspectionId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): BookingListDto {
        const json = this.toJSON();
        let result = new BookingListDto();
        result.init(json);
        return result;
    }
}

export interface IBookingListDto {
    externalIdentifier: string | undefined;
    thirdPartyName: string | undefined;
    bookingTime: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    customerName: string | undefined;
    customerPhoneNumber: string | undefined;
    customerEmail: string | undefined;
    companyName: string | undefined;
    businessCustomerCode: string | undefined;
    regoOrLast6DigitVIN: string | undefined;
    vehicleMake: string | undefined;
    vehicleModel: string | undefined;
    colour: string | undefined;
    hasCurrentWofAndRego: boolean | undefined;
    canBeDisclosedToAnyone: boolean | undefined;
    reportEmailDelivery: boolean | undefined;
    reportHardCopyDelivery: boolean | undefined;
    buyingOrSelling: boolean | undefined;
    additionalComments: string | undefined;
    bookingStatus: string | undefined;
    inspectionId: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class PagedResultRequestDto implements IPagedResultRequestDto {
    maxResultCount: number | undefined;
    skipCount: number | undefined;

    constructor(data?: IPagedResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    }

    static fromJS(data: any): PagedResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }

    clone(): PagedResultRequestDto {
        const json = this.toJSON();
        let result = new PagedResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultRequestDto {
    maxResultCount: number | undefined;
    skipCount: number | undefined;
}

export class ListResultDtoOfRecentInspectionListDto implements IListResultDtoOfRecentInspectionListDto {
    items: RecentInspectionListDto[] | undefined;

    constructor(data?: IListResultDtoOfRecentInspectionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RecentInspectionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRecentInspectionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRecentInspectionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRecentInspectionListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRecentInspectionListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRecentInspectionListDto {
    items: RecentInspectionListDto[] | undefined;
}

export class RecentInspectionListDto implements IRecentInspectionListDto {
    inspectionId: string | undefined;
    registrationNumber: string | undefined;
    vinNumber: string | undefined;
    stockNumber: string | undefined;
    inspectionCreationTime: moment.Moment | undefined;
    inspectionTypeName: string | undefined;
    inspectionVersionName: string | undefined;
    inspectionTypeId: string | undefined;
    counters: SelectionCountersDto[] | undefined;
    inspectionStatusName: string | undefined;
    inspectionStatusId: string | undefined;
    overallStatus: string | undefined;

    constructor(data?: IRecentInspectionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionId = data["inspectionId"];
            this.registrationNumber = data["registrationNumber"];
            this.vinNumber = data["vinNumber"];
            this.stockNumber = data["stockNumber"];
            this.inspectionCreationTime = data["inspectionCreationTime"] ? moment(data["inspectionCreationTime"].toString()) : <any>undefined;
            this.inspectionTypeName = data["inspectionTypeName"];
            this.inspectionVersionName = data["inspectionVersionName"];
            this.inspectionTypeId = data["inspectionTypeId"];
            if (data["counters"] && data["counters"].constructor === Array) {
                this.counters = [] as any;
                for (let item of data["counters"])
                    this.counters.push(SelectionCountersDto.fromJS(item));
            }
            this.inspectionStatusName = data["inspectionStatusName"];
            this.inspectionStatusId = data["inspectionStatusId"];
            this.overallStatus = data["overallStatus"];
        }
    }

    static fromJS(data: any): RecentInspectionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecentInspectionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["registrationNumber"] = this.registrationNumber;
        data["vinNumber"] = this.vinNumber;
        data["stockNumber"] = this.stockNumber;
        data["inspectionCreationTime"] = this.inspectionCreationTime ? this.inspectionCreationTime.toISOString() : <any>undefined;
        data["inspectionTypeName"] = this.inspectionTypeName;
        data["inspectionVersionName"] = this.inspectionVersionName;
        data["inspectionTypeId"] = this.inspectionTypeId;
        if (this.counters && this.counters.constructor === Array) {
            data["counters"] = [];
            for (let item of this.counters)
                data["counters"].push(item.toJSON());
        }
        data["inspectionStatusName"] = this.inspectionStatusName;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["overallStatus"] = this.overallStatus;
        return data; 
    }

    clone(): RecentInspectionListDto {
        const json = this.toJSON();
        let result = new RecentInspectionListDto();
        result.init(json);
        return result;
    }
}

export interface IRecentInspectionListDto {
    inspectionId: string | undefined;
    registrationNumber: string | undefined;
    vinNumber: string | undefined;
    stockNumber: string | undefined;
    inspectionCreationTime: moment.Moment | undefined;
    inspectionTypeName: string | undefined;
    inspectionVersionName: string | undefined;
    inspectionTypeId: string | undefined;
    counters: SelectionCountersDto[] | undefined;
    inspectionStatusName: string | undefined;
    inspectionStatusId: string | undefined;
    overallStatus: string | undefined;
}

export class SelectionCountersDto implements ISelectionCountersDto {
    id: string | undefined;
    key: string | undefined;
    shortName: string | undefined;
    value: number | undefined;

    constructor(data?: ISelectionCountersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.key = data["key"];
            this.shortName = data["shortName"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SelectionCountersDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionCountersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["shortName"] = this.shortName;
        data["value"] = this.value;
        return data; 
    }

    clone(): SelectionCountersDto {
        const json = this.toJSON();
        let result = new SelectionCountersDto();
        result.init(json);
        return result;
    }
}

export interface ISelectionCountersDto {
    id: string | undefined;
    key: string | undefined;
    shortName: string | undefined;
    value: number | undefined;
}

export class InspectionDetailCreateRequestDto implements IInspectionDetailCreateRequestDto {
    value: string | undefined;
    inspectionPointId: string | undefined;
    inspectionId: string | undefined;
    comment: string | undefined;

    constructor(data?: IInspectionDetailCreateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.inspectionPointId = data["inspectionPointId"];
            this.inspectionId = data["inspectionId"];
            this.comment = data["comment"];
        }
    }

    static fromJS(data: any): InspectionDetailCreateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetailCreateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["inspectionPointId"] = this.inspectionPointId;
        data["inspectionId"] = this.inspectionId;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): InspectionDetailCreateRequestDto {
        const json = this.toJSON();
        let result = new InspectionDetailCreateRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionDetailCreateRequestDto {
    value: string | undefined;
    inspectionPointId: string | undefined;
    inspectionId: string | undefined;
    comment: string | undefined;
}

export class InspectionDetailListDto implements IInspectionDetailListDto {
    value: string | undefined;
    inspectionPointId: string | undefined;
    inspectionId: string | undefined;
    commentId: string | undefined;

    constructor(data?: IInspectionDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.inspectionPointId = data["inspectionPointId"];
            this.inspectionId = data["inspectionId"];
            this.commentId = data["commentId"];
        }
    }

    static fromJS(data: any): InspectionDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["inspectionPointId"] = this.inspectionPointId;
        data["inspectionId"] = this.inspectionId;
        data["commentId"] = this.commentId;
        return data; 
    }

    clone(): InspectionDetailListDto {
        const json = this.toJSON();
        let result = new InspectionDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionDetailListDto {
    value: string | undefined;
    inspectionPointId: string | undefined;
    inspectionId: string | undefined;
    commentId: string | undefined;
}

export class ListResultDtoOfCategorizedInspectionPointListDto implements IListResultDtoOfCategorizedInspectionPointListDto {
    items: CategorizedInspectionPointListDto[] | undefined;

    constructor(data?: IListResultDtoOfCategorizedInspectionPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CategorizedInspectionPointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCategorizedInspectionPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCategorizedInspectionPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCategorizedInspectionPointListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCategorizedInspectionPointListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCategorizedInspectionPointListDto {
    items: CategorizedInspectionPointListDto[] | undefined;
}

export class CategorizedInspectionPointListDto implements ICategorizedInspectionPointListDto {
    categoryId: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    inspectionPoints: InspectionPointListDto[] | undefined;

    constructor(data?: ICategorizedInspectionPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            if (data["inspectionPoints"] && data["inspectionPoints"].constructor === Array) {
                this.inspectionPoints = [] as any;
                for (let item of data["inspectionPoints"])
                    this.inspectionPoints.push(InspectionPointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategorizedInspectionPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorizedInspectionPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (this.inspectionPoints && this.inspectionPoints.constructor === Array) {
            data["inspectionPoints"] = [];
            for (let item of this.inspectionPoints)
                data["inspectionPoints"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CategorizedInspectionPointListDto {
        const json = this.toJSON();
        let result = new CategorizedInspectionPointListDto();
        result.init(json);
        return result;
    }
}

export interface ICategorizedInspectionPointListDto {
    categoryId: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    inspectionPoints: InspectionPointListDto[] | undefined;
}

export class InspectionPointListDto implements IInspectionPointListDto {
    id: string | undefined;
    name: string | undefined;
    dataTypeId: string | undefined;
    dataTypeName: string | undefined;
    unitOfMeasureId: string | undefined;
    unitOfMeasureName: string | undefined;
    apiToUse: string | undefined;
    apiUsageGuide: string | undefined;
    code: string | undefined;
    regexValidation: string | undefined;
    isRequired: boolean | undefined;
    parentId: string | undefined;
    childIds: string[] | undefined;
    categories: LookupNameDto[] | undefined;
    inspectionTypes: InspectionTypesLimitedListDto[] | undefined;
    selected: boolean | undefined;

    constructor(data?: IInspectionPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.dataTypeId = data["dataTypeId"];
            this.dataTypeName = data["dataTypeName"];
            this.unitOfMeasureId = data["unitOfMeasureId"];
            this.unitOfMeasureName = data["unitOfMeasureName"];
            this.apiToUse = data["apiToUse"];
            this.apiUsageGuide = data["apiUsageGuide"];
            this.code = data["code"];
            this.regexValidation = data["regexValidation"];
            this.isRequired = data["isRequired"];
            this.parentId = data["parentId"];
            if (data["childIds"] && data["childIds"].constructor === Array) {
                this.childIds = [] as any;
                for (let item of data["childIds"])
                    this.childIds.push(item);
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories.push(LookupNameDto.fromJS(item));
            }
            if (data["inspectionTypes"] && data["inspectionTypes"].constructor === Array) {
                this.inspectionTypes = [] as any;
                for (let item of data["inspectionTypes"])
                    this.inspectionTypes.push(InspectionTypesLimitedListDto.fromJS(item));
            }
            this.selected = data["selected"];
        }
    }

    static fromJS(data: any): InspectionPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataTypeId"] = this.dataTypeId;
        data["dataTypeName"] = this.dataTypeName;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasureName"] = this.unitOfMeasureName;
        data["apiToUse"] = this.apiToUse;
        data["apiUsageGuide"] = this.apiUsageGuide;
        data["code"] = this.code;
        data["regexValidation"] = this.regexValidation;
        data["isRequired"] = this.isRequired;
        data["parentId"] = this.parentId;
        if (this.childIds && this.childIds.constructor === Array) {
            data["childIds"] = [];
            for (let item of this.childIds)
                data["childIds"].push(item);
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (this.inspectionTypes && this.inspectionTypes.constructor === Array) {
            data["inspectionTypes"] = [];
            for (let item of this.inspectionTypes)
                data["inspectionTypes"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        return data; 
    }

    clone(): InspectionPointListDto {
        const json = this.toJSON();
        let result = new InspectionPointListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionPointListDto {
    id: string | undefined;
    name: string | undefined;
    dataTypeId: string | undefined;
    dataTypeName: string | undefined;
    unitOfMeasureId: string | undefined;
    unitOfMeasureName: string | undefined;
    apiToUse: string | undefined;
    apiUsageGuide: string | undefined;
    code: string | undefined;
    regexValidation: string | undefined;
    isRequired: boolean | undefined;
    parentId: string | undefined;
    childIds: string[] | undefined;
    categories: LookupNameDto[] | undefined;
    inspectionTypes: InspectionTypesLimitedListDto[] | undefined;
    selected: boolean | undefined;
}

export class InspectionTypesLimitedListDto implements IInspectionTypesLimitedListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    externalId: number | undefined;

    constructor(data?: IInspectionTypesLimitedListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.externalId = data["externalId"];
        }
    }

    static fromJS(data: any): InspectionTypesLimitedListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypesLimitedListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["externalId"] = this.externalId;
        return data; 
    }

    clone(): InspectionTypesLimitedListDto {
        const json = this.toJSON();
        let result = new InspectionTypesLimitedListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionTypesLimitedListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    externalId: number | undefined;
}

export class ListResultDtoOfInspectionPointListDto implements IListResultDtoOfInspectionPointListDto {
    items: InspectionPointListDto[] | undefined;

    constructor(data?: IListResultDtoOfInspectionPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(InspectionPointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInspectionPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfInspectionPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfInspectionPointListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfInspectionPointListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfInspectionPointListDto {
    items: InspectionPointListDto[] | undefined;
}

export class ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto implements IListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto {
    items: CategorizedInspectionPointByInspectionTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CategorizedInspectionPointByInspectionTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCategorizedInspectionPointByInspectionTypeListDto {
    items: CategorizedInspectionPointByInspectionTypeListDto[] | undefined;
}

export class CategorizedInspectionPointByInspectionTypeListDto implements ICategorizedInspectionPointByInspectionTypeListDto {
    inspectionTypeId: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    inspectionPoints: InspectionPointListDto[] | undefined;

    constructor(data?: ICategorizedInspectionPointByInspectionTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionTypeId = data["inspectionTypeId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            if (data["inspectionPoints"] && data["inspectionPoints"].constructor === Array) {
                this.inspectionPoints = [] as any;
                for (let item of data["inspectionPoints"])
                    this.inspectionPoints.push(InspectionPointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategorizedInspectionPointByInspectionTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorizedInspectionPointByInspectionTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (this.inspectionPoints && this.inspectionPoints.constructor === Array) {
            data["inspectionPoints"] = [];
            for (let item of this.inspectionPoints)
                data["inspectionPoints"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CategorizedInspectionPointByInspectionTypeListDto {
        const json = this.toJSON();
        let result = new CategorizedInspectionPointByInspectionTypeListDto();
        result.init(json);
        return result;
    }
}

export interface ICategorizedInspectionPointByInspectionTypeListDto {
    inspectionTypeId: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    inspectionPoints: InspectionPointListDto[] | undefined;
}

export class ListResultDtoOfInspectionTypesListDto implements IListResultDtoOfInspectionTypesListDto {
    items: InspectionTypesListDto[] | undefined;

    constructor(data?: IListResultDtoOfInspectionTypesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(InspectionTypesListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInspectionTypesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfInspectionTypesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfInspectionTypesListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfInspectionTypesListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfInspectionTypesListDto {
    items: InspectionTypesListDto[] | undefined;
}

export class InspectionTypesListDto implements IInspectionTypesListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    templateHtml: string | undefined;
    externalId: number | undefined;
    inspectionCriteriaId: string | undefined;

    constructor(data?: IInspectionTypesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.templateHtml = data["templateHtml"];
            this.externalId = data["externalId"];
            this.inspectionCriteriaId = data["inspectionCriteriaId"];
        }
    }

    static fromJS(data: any): InspectionTypesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["templateHtml"] = this.templateHtml;
        data["externalId"] = this.externalId;
        data["inspectionCriteriaId"] = this.inspectionCriteriaId;
        return data; 
    }

    clone(): InspectionTypesListDto {
        const json = this.toJSON();
        let result = new InspectionTypesListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionTypesListDto {
    id: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    templateHtml: string | undefined;
    externalId: number | undefined;
    inspectionCriteriaId: string | undefined;
}

export class InspectionTypeDto implements IInspectionTypeDto {
    name: string;
    tenantName: string | undefined;
    displayName: string | undefined;
    templateHTML: string | undefined;
    externalId: number | undefined;
    tenantId: number | undefined;
    photoNames: string | undefined;
    code: string | undefined;
    inspectionCriteriaId: string | undefined;
    slug: string | undefined;
    additionalPhotosAllowed: boolean | undefined;
    allowInspectorsToAddCustomers: boolean | undefined;
    allowInspectorsToEditCustomers: boolean | undefined;
    allowManagerMessageOnReportSummary: boolean | undefined;
    disclaimerText: string | undefined;
    hideDisclaimerText: boolean | undefined;
    termsAndConditions: string | undefined;
    hideTermsAndConditions: boolean | undefined;
    explainerCopy: string | undefined;
    hideExplainerCopy: boolean | undefined;
    draft: boolean | undefined;
    draftCategorizedInspectionPoints: string | undefined;
    categorizedInspectionPoints: CategorizedInspectionPointListDto[] | undefined;
    try1Pager: boolean | undefined;
    allowVersioning: boolean | undefined;
    changeTireDriveCategoryName: boolean | undefined;
    id: string | undefined;

    constructor(data?: IInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.tenantName = data["tenantName"];
            this.displayName = data["displayName"];
            this.templateHTML = data["templateHTML"];
            this.externalId = data["externalId"];
            this.tenantId = data["tenantId"];
            this.photoNames = data["photoNames"];
            this.code = data["code"];
            this.inspectionCriteriaId = data["inspectionCriteriaId"];
            this.slug = data["slug"];
            this.additionalPhotosAllowed = data["additionalPhotosAllowed"];
            this.allowInspectorsToAddCustomers = data["allowInspectorsToAddCustomers"];
            this.allowInspectorsToEditCustomers = data["allowInspectorsToEditCustomers"];
            this.allowManagerMessageOnReportSummary = data["allowManagerMessageOnReportSummary"];
            this.disclaimerText = data["disclaimerText"];
            this.hideDisclaimerText = data["hideDisclaimerText"];
            this.termsAndConditions = data["termsAndConditions"];
            this.hideTermsAndConditions = data["hideTermsAndConditions"];
            this.explainerCopy = data["explainerCopy"];
            this.hideExplainerCopy = data["hideExplainerCopy"];
            this.draft = data["draft"];
            this.draftCategorizedInspectionPoints = data["draftCategorizedInspectionPoints"];
            if (data["categorizedInspectionPoints"] && data["categorizedInspectionPoints"].constructor === Array) {
                this.categorizedInspectionPoints = [] as any;
                for (let item of data["categorizedInspectionPoints"])
                    this.categorizedInspectionPoints.push(CategorizedInspectionPointListDto.fromJS(item));
            }
            this.try1Pager = data["try1Pager"];
            this.allowVersioning = data["allowVersioning"];
            this.changeTireDriveCategoryName = data["changeTireDriveCategoryName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenantName"] = this.tenantName;
        data["displayName"] = this.displayName;
        data["templateHTML"] = this.templateHTML;
        data["externalId"] = this.externalId;
        data["tenantId"] = this.tenantId;
        data["photoNames"] = this.photoNames;
        data["code"] = this.code;
        data["inspectionCriteriaId"] = this.inspectionCriteriaId;
        data["slug"] = this.slug;
        data["additionalPhotosAllowed"] = this.additionalPhotosAllowed;
        data["allowInspectorsToAddCustomers"] = this.allowInspectorsToAddCustomers;
        data["allowInspectorsToEditCustomers"] = this.allowInspectorsToEditCustomers;
        data["allowManagerMessageOnReportSummary"] = this.allowManagerMessageOnReportSummary;
        data["disclaimerText"] = this.disclaimerText;
        data["hideDisclaimerText"] = this.hideDisclaimerText;
        data["termsAndConditions"] = this.termsAndConditions;
        data["hideTermsAndConditions"] = this.hideTermsAndConditions;
        data["explainerCopy"] = this.explainerCopy;
        data["hideExplainerCopy"] = this.hideExplainerCopy;
        data["draft"] = this.draft;
        data["draftCategorizedInspectionPoints"] = this.draftCategorizedInspectionPoints;
        if (this.categorizedInspectionPoints && this.categorizedInspectionPoints.constructor === Array) {
            data["categorizedInspectionPoints"] = [];
            for (let item of this.categorizedInspectionPoints)
                data["categorizedInspectionPoints"].push(item.toJSON());
        }
        data["try1Pager"] = this.try1Pager;
        data["allowVersioning"] = this.allowVersioning;
        data["changeTireDriveCategoryName"] = this.changeTireDriveCategoryName;
        data["id"] = this.id;
        return data; 
    }

    clone(): InspectionTypeDto {
        const json = this.toJSON();
        let result = new InspectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionTypeDto {
    name: string;
    tenantName: string | undefined;
    displayName: string | undefined;
    templateHTML: string | undefined;
    externalId: number | undefined;
    tenantId: number | undefined;
    photoNames: string | undefined;
    code: string | undefined;
    inspectionCriteriaId: string | undefined;
    slug: string | undefined;
    additionalPhotosAllowed: boolean | undefined;
    allowInspectorsToAddCustomers: boolean | undefined;
    allowInspectorsToEditCustomers: boolean | undefined;
    allowManagerMessageOnReportSummary: boolean | undefined;
    disclaimerText: string | undefined;
    hideDisclaimerText: boolean | undefined;
    termsAndConditions: string | undefined;
    hideTermsAndConditions: boolean | undefined;
    explainerCopy: string | undefined;
    hideExplainerCopy: boolean | undefined;
    draft: boolean | undefined;
    draftCategorizedInspectionPoints: string | undefined;
    categorizedInspectionPoints: CategorizedInspectionPointListDto[] | undefined;
    try1Pager: boolean | undefined;
    allowVersioning: boolean | undefined;
    changeTireDriveCategoryName: boolean | undefined;
    id: string | undefined;
}

export class CreateInspectionTypeDto implements ICreateInspectionTypeDto {
    tenantId: number;
    name: string;
    displayName: string;
    externalId: number | undefined;
    photoNames: string | undefined;
    slug: string | undefined;
    additionalPhotosAllowed: boolean | undefined;
    allowInspectorsToAddCustomers: boolean | undefined;
    allowInspectorsToEditCustomers: boolean | undefined;
    allowManagerMessageOnReportSummary: boolean | undefined;
    disclaimerText: string | undefined;
    hideDisclaimerText: boolean | undefined;
    termsAndConditions: string | undefined;
    hideTermsAndConditions: boolean | undefined;
    explainerCopy: string | undefined;
    hideExplainerCopy: boolean | undefined;
    draft: boolean | undefined;
    code: string | undefined;
    inspectionCriteriaId: string | undefined;
    categorizedInspectionPoints: CategorizedInspectionPointListDto[] | undefined;
    draftCategorizedInspectionPoints: string | undefined;
    try1Pager: boolean | undefined;
    allowVersioning: boolean | undefined;
    changeTireDriveCategoryName: boolean | undefined;
    id: string | undefined;

    constructor(data?: ICreateInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.externalId = data["externalId"];
            this.photoNames = data["photoNames"];
            this.slug = data["slug"];
            this.additionalPhotosAllowed = data["additionalPhotosAllowed"];
            this.allowInspectorsToAddCustomers = data["allowInspectorsToAddCustomers"];
            this.allowInspectorsToEditCustomers = data["allowInspectorsToEditCustomers"];
            this.allowManagerMessageOnReportSummary = data["allowManagerMessageOnReportSummary"];
            this.disclaimerText = data["disclaimerText"];
            this.hideDisclaimerText = data["hideDisclaimerText"];
            this.termsAndConditions = data["termsAndConditions"];
            this.hideTermsAndConditions = data["hideTermsAndConditions"];
            this.explainerCopy = data["explainerCopy"];
            this.hideExplainerCopy = data["hideExplainerCopy"];
            this.draft = data["draft"];
            this.code = data["code"];
            this.inspectionCriteriaId = data["inspectionCriteriaId"];
            if (data["categorizedInspectionPoints"] && data["categorizedInspectionPoints"].constructor === Array) {
                this.categorizedInspectionPoints = [] as any;
                for (let item of data["categorizedInspectionPoints"])
                    this.categorizedInspectionPoints.push(CategorizedInspectionPointListDto.fromJS(item));
            }
            this.draftCategorizedInspectionPoints = data["draftCategorizedInspectionPoints"];
            this.try1Pager = data["try1Pager"];
            this.allowVersioning = data["allowVersioning"];
            this.changeTireDriveCategoryName = data["changeTireDriveCategoryName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateInspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["externalId"] = this.externalId;
        data["photoNames"] = this.photoNames;
        data["slug"] = this.slug;
        data["additionalPhotosAllowed"] = this.additionalPhotosAllowed;
        data["allowInspectorsToAddCustomers"] = this.allowInspectorsToAddCustomers;
        data["allowInspectorsToEditCustomers"] = this.allowInspectorsToEditCustomers;
        data["allowManagerMessageOnReportSummary"] = this.allowManagerMessageOnReportSummary;
        data["disclaimerText"] = this.disclaimerText;
        data["hideDisclaimerText"] = this.hideDisclaimerText;
        data["termsAndConditions"] = this.termsAndConditions;
        data["hideTermsAndConditions"] = this.hideTermsAndConditions;
        data["explainerCopy"] = this.explainerCopy;
        data["hideExplainerCopy"] = this.hideExplainerCopy;
        data["draft"] = this.draft;
        data["code"] = this.code;
        data["inspectionCriteriaId"] = this.inspectionCriteriaId;
        if (this.categorizedInspectionPoints && this.categorizedInspectionPoints.constructor === Array) {
            data["categorizedInspectionPoints"] = [];
            for (let item of this.categorizedInspectionPoints)
                data["categorizedInspectionPoints"].push(item.toJSON());
        }
        data["draftCategorizedInspectionPoints"] = this.draftCategorizedInspectionPoints;
        data["try1Pager"] = this.try1Pager;
        data["allowVersioning"] = this.allowVersioning;
        data["changeTireDriveCategoryName"] = this.changeTireDriveCategoryName;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateInspectionTypeDto {
        const json = this.toJSON();
        let result = new CreateInspectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInspectionTypeDto {
    tenantId: number;
    name: string;
    displayName: string;
    externalId: number | undefined;
    photoNames: string | undefined;
    slug: string | undefined;
    additionalPhotosAllowed: boolean | undefined;
    allowInspectorsToAddCustomers: boolean | undefined;
    allowInspectorsToEditCustomers: boolean | undefined;
    allowManagerMessageOnReportSummary: boolean | undefined;
    disclaimerText: string | undefined;
    hideDisclaimerText: boolean | undefined;
    termsAndConditions: string | undefined;
    hideTermsAndConditions: boolean | undefined;
    explainerCopy: string | undefined;
    hideExplainerCopy: boolean | undefined;
    draft: boolean | undefined;
    code: string | undefined;
    inspectionCriteriaId: string | undefined;
    categorizedInspectionPoints: CategorizedInspectionPointListDto[] | undefined;
    draftCategorizedInspectionPoints: string | undefined;
    try1Pager: boolean | undefined;
    allowVersioning: boolean | undefined;
    changeTireDriveCategoryName: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfInspectionTypeDto implements IPagedResultDtoOfInspectionTypeDto {
    totalCount: number | undefined;
    items: InspectionTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInspectionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(InspectionTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInspectionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInspectionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfInspectionTypeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfInspectionTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfInspectionTypeDto {
    totalCount: number | undefined;
    items: InspectionTypeDto[] | undefined;
}

export class InspectionVersionListDto implements IInspectionVersionListDto {
    versionName: string | undefined;
    isLatest: boolean | undefined;
    inspectionId: string | undefined;
    previousVersionInspectionId: string | undefined;
    vehicleId: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IInspectionVersionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.versionName = data["versionName"];
            this.isLatest = data["isLatest"];
            this.inspectionId = data["inspectionId"];
            this.previousVersionInspectionId = data["previousVersionInspectionId"];
            this.vehicleId = data["vehicleId"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InspectionVersionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionVersionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionName"] = this.versionName;
        data["isLatest"] = this.isLatest;
        data["inspectionId"] = this.inspectionId;
        data["previousVersionInspectionId"] = this.previousVersionInspectionId;
        data["vehicleId"] = this.vehicleId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InspectionVersionListDto {
        const json = this.toJSON();
        let result = new InspectionVersionListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionVersionListDto {
    versionName: string | undefined;
    isLatest: boolean | undefined;
    inspectionId: string | undefined;
    previousVersionInspectionId: string | undefined;
    vehicleId: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class ListResultDtoOfInspectionVersionListDto implements IListResultDtoOfInspectionVersionListDto {
    items: InspectionVersionListDto[] | undefined;

    constructor(data?: IListResultDtoOfInspectionVersionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(InspectionVersionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInspectionVersionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfInspectionVersionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfInspectionVersionListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfInspectionVersionListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfInspectionVersionListDto {
    items: InspectionVersionListDto[] | undefined;
}

export class PastInspectionRequestDto implements IPastInspectionRequestDto {
    vehicleId: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IPastInspectionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vehicleId = data["vehicleId"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): PastInspectionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PastInspectionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): PastInspectionRequestDto {
        const json = this.toJSON();
        let result = new PastInspectionRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPastInspectionRequestDto {
    vehicleId: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ListResultDtoOfPastInspectionsListDto implements IListResultDtoOfPastInspectionsListDto {
    items: PastInspectionsListDto[] | undefined;

    constructor(data?: IListResultDtoOfPastInspectionsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(PastInspectionsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPastInspectionsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPastInspectionsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfPastInspectionsListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPastInspectionsListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPastInspectionsListDto {
    items: PastInspectionsListDto[] | undefined;
}

export class PastInspectionsListDto implements IPastInspectionsListDto {
    inspectionId: string | undefined;
    inspectionCreationTime: moment.Moment | undefined;
    inspectionVersionName: string | undefined;
    registrationNumber: string | undefined;
    vinNumber: string | undefined;
    stockNumber: string | undefined;
    inspectionTypeName: string | undefined;
    inspectionTypeId: string | undefined;
    counters: SelectionCountersDto[] | undefined;
    inspectionStatusName: string | undefined;
    inspectionStatusId: string | undefined;
    overallStatus: string | undefined;

    constructor(data?: IPastInspectionsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionId = data["inspectionId"];
            this.inspectionCreationTime = data["inspectionCreationTime"] ? moment(data["inspectionCreationTime"].toString()) : <any>undefined;
            this.inspectionVersionName = data["inspectionVersionName"];
            this.registrationNumber = data["registrationNumber"];
            this.vinNumber = data["vinNumber"];
            this.stockNumber = data["stockNumber"];
            this.inspectionTypeName = data["inspectionTypeName"];
            this.inspectionTypeId = data["inspectionTypeId"];
            if (data["counters"] && data["counters"].constructor === Array) {
                this.counters = [] as any;
                for (let item of data["counters"])
                    this.counters.push(SelectionCountersDto.fromJS(item));
            }
            this.inspectionStatusName = data["inspectionStatusName"];
            this.inspectionStatusId = data["inspectionStatusId"];
            this.overallStatus = data["overallStatus"];
        }
    }

    static fromJS(data: any): PastInspectionsListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PastInspectionsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["inspectionCreationTime"] = this.inspectionCreationTime ? this.inspectionCreationTime.toISOString() : <any>undefined;
        data["inspectionVersionName"] = this.inspectionVersionName;
        data["registrationNumber"] = this.registrationNumber;
        data["vinNumber"] = this.vinNumber;
        data["stockNumber"] = this.stockNumber;
        data["inspectionTypeName"] = this.inspectionTypeName;
        data["inspectionTypeId"] = this.inspectionTypeId;
        if (this.counters && this.counters.constructor === Array) {
            data["counters"] = [];
            for (let item of this.counters)
                data["counters"].push(item.toJSON());
        }
        data["inspectionStatusName"] = this.inspectionStatusName;
        data["inspectionStatusId"] = this.inspectionStatusId;
        data["overallStatus"] = this.overallStatus;
        return data; 
    }

    clone(): PastInspectionsListDto {
        const json = this.toJSON();
        let result = new PastInspectionsListDto();
        result.init(json);
        return result;
    }
}

export interface IPastInspectionsListDto {
    inspectionId: string | undefined;
    inspectionCreationTime: moment.Moment | undefined;
    inspectionVersionName: string | undefined;
    registrationNumber: string | undefined;
    vinNumber: string | undefined;
    stockNumber: string | undefined;
    inspectionTypeName: string | undefined;
    inspectionTypeId: string | undefined;
    counters: SelectionCountersDto[] | undefined;
    inspectionStatusName: string | undefined;
    inspectionStatusId: string | undefined;
    overallStatus: string | undefined;
}

export class ListResultDtoOfLK_GenericLookupsDto implements IListResultDtoOfLK_GenericLookupsDto {
    items: LK_GenericLookupsDto[] | undefined;

    constructor(data?: IListResultDtoOfLK_GenericLookupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(LK_GenericLookupsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLK_GenericLookupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLK_GenericLookupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfLK_GenericLookupsDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfLK_GenericLookupsDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfLK_GenericLookupsDto {
    items: LK_GenericLookupsDto[] | undefined;
}

export class LK_GenericLookupsDto implements ILK_GenericLookupsDto {
    id: string | undefined;
    type: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    parentId: string | undefined;
    displayColor: string | undefined;

    constructor(data?: ILK_GenericLookupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.type = data["type"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.value = data["value"];
            this.parentId = data["parentId"];
            this.displayColor = data["displayColor"];
        }
    }

    static fromJS(data: any): LK_GenericLookupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LK_GenericLookupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["parentId"] = this.parentId;
        data["displayColor"] = this.displayColor;
        return data; 
    }

    clone(): LK_GenericLookupsDto {
        const json = this.toJSON();
        let result = new LK_GenericLookupsDto();
        result.init(json);
        return result;
    }
}

export interface ILK_GenericLookupsDto {
    id: string | undefined;
    type: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    parentId: string | undefined;
    displayColor: string | undefined;
}

export class LK_InspectionCriteriaDto implements ILK_InspectionCriteriaDto {
    name: string | undefined;
    photoPath: string | undefined;
    code: string | undefined;
    dataTypeId: string | undefined;
    id: string | undefined;

    constructor(data?: ILK_InspectionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.photoPath = data["photoPath"];
            this.code = data["code"];
            this.dataTypeId = data["dataTypeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LK_InspectionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LK_InspectionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["photoPath"] = this.photoPath;
        data["code"] = this.code;
        data["dataTypeId"] = this.dataTypeId;
        data["id"] = this.id;
        return data; 
    }

    clone(): LK_InspectionCriteriaDto {
        const json = this.toJSON();
        let result = new LK_InspectionCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface ILK_InspectionCriteriaDto {
    name: string | undefined;
    photoPath: string | undefined;
    code: string | undefined;
    dataTypeId: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfLK_InspectionCriteriaDto implements IPagedResultDtoOfLK_InspectionCriteriaDto {
    totalCount: number | undefined;
    items: LK_InspectionCriteriaDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLK_InspectionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(LK_InspectionCriteriaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLK_InspectionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLK_InspectionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfLK_InspectionCriteriaDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLK_InspectionCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLK_InspectionCriteriaDto {
    totalCount: number | undefined;
    items: LK_InspectionCriteriaDto[] | undefined;
}

export class CreateInspectionCriteriaDto implements ICreateInspectionCriteriaDto {
    name: string | undefined;
    photoPath: string | undefined;
    code: string | undefined;
    dataTypeId: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateInspectionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.photoPath = data["photoPath"];
            this.code = data["code"];
            this.dataTypeId = data["dataTypeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateInspectionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInspectionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["photoPath"] = this.photoPath;
        data["code"] = this.code;
        data["dataTypeId"] = this.dataTypeId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateInspectionCriteriaDto {
        const json = this.toJSON();
        let result = new CreateInspectionCriteriaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInspectionCriteriaDto {
    name: string | undefined;
    photoPath: string | undefined;
    code: string | undefined;
    dataTypeId: string | undefined;
    id: string | undefined;
}

export class UploadPhotoResponseDto implements IUploadPhotoResponseDto {
    path: string | undefined;
    description: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IUploadPhotoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.description = data["description"];
            if (data["photoAssociations"] && data["photoAssociations"].constructor === Array) {
                this.photoAssociations = [] as any;
                for (let item of data["photoAssociations"])
                    this.photoAssociations.push(PhotoAssociationListDto.fromJS(item));
            }
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UploadPhotoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPhotoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["description"] = this.description;
        if (this.photoAssociations && this.photoAssociations.constructor === Array) {
            data["photoAssociations"] = [];
            for (let item of this.photoAssociations)
                data["photoAssociations"].push(item.toJSON());
        }
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UploadPhotoResponseDto {
        const json = this.toJSON();
        let result = new UploadPhotoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUploadPhotoResponseDto {
    path: string | undefined;
    description: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class PhotoAssociationListDto implements IPhotoAssociationListDto {
    type: string | undefined;
    photoId: string | undefined;
    associationId: string | undefined;
    tag: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IPhotoAssociationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.photoId = data["photoId"];
            this.associationId = data["associationId"];
            this.tag = data["tag"];
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PhotoAssociationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoAssociationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["photoId"] = this.photoId;
        data["associationId"] = this.associationId;
        data["tag"] = this.tag;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PhotoAssociationListDto {
        const json = this.toJSON();
        let result = new PhotoAssociationListDto();
        result.init(json);
        return result;
    }
}

export interface IPhotoAssociationListDto {
    type: string | undefined;
    photoId: string | undefined;
    associationId: string | undefined;
    tag: string | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class ListResultDtoOfGetPhotosResponseDto implements IListResultDtoOfGetPhotosResponseDto {
    items: GetPhotosResponseDto[] | undefined;

    constructor(data?: IListResultDtoOfGetPhotosResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetPhotosResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetPhotosResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetPhotosResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfGetPhotosResponseDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfGetPhotosResponseDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfGetPhotosResponseDto {
    items: GetPhotosResponseDto[] | undefined;
}

export class GetPhotosResponseDto implements IGetPhotosResponseDto {
    description: string | undefined;
    path: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IGetPhotosResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.path = data["path"];
            if (data["photoAssociations"] && data["photoAssociations"].constructor === Array) {
                this.photoAssociations = [] as any;
                for (let item of data["photoAssociations"])
                    this.photoAssociations.push(PhotoAssociationListDto.fromJS(item));
            }
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetPhotosResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhotosResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["path"] = this.path;
        if (this.photoAssociations && this.photoAssociations.constructor === Array) {
            data["photoAssociations"] = [];
            for (let item of this.photoAssociations)
                data["photoAssociations"].push(item.toJSON());
        }
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetPhotosResponseDto {
        const json = this.toJSON();
        let result = new GetPhotosResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetPhotosResponseDto {
    description: string | undefined;
    path: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class ListResultDtoOfInspectionPointPhotoListDto implements IListResultDtoOfInspectionPointPhotoListDto {
    items: InspectionPointPhotoListDto[] | undefined;

    constructor(data?: IListResultDtoOfInspectionPointPhotoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(InspectionPointPhotoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInspectionPointPhotoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfInspectionPointPhotoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfInspectionPointPhotoListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfInspectionPointPhotoListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfInspectionPointPhotoListDto {
    items: InspectionPointPhotoListDto[] | undefined;
}

export class InspectionPointPhotoListDto implements IInspectionPointPhotoListDto {
    description: string | undefined;
    path: string | undefined;
    categoryName: string | undefined;
    categoryCode: string | undefined;
    inspectionPointName: string | undefined;
    inspectionPointCode: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IInspectionPointPhotoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.path = data["path"];
            this.categoryName = data["categoryName"];
            this.categoryCode = data["categoryCode"];
            this.inspectionPointName = data["inspectionPointName"];
            this.inspectionPointCode = data["inspectionPointCode"];
            if (data["photoAssociations"] && data["photoAssociations"].constructor === Array) {
                this.photoAssociations = [] as any;
                for (let item of data["photoAssociations"])
                    this.photoAssociations.push(PhotoAssociationListDto.fromJS(item));
            }
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InspectionPointPhotoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionPointPhotoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["path"] = this.path;
        data["categoryName"] = this.categoryName;
        data["categoryCode"] = this.categoryCode;
        data["inspectionPointName"] = this.inspectionPointName;
        data["inspectionPointCode"] = this.inspectionPointCode;
        if (this.photoAssociations && this.photoAssociations.constructor === Array) {
            data["photoAssociations"] = [];
            for (let item of this.photoAssociations)
                data["photoAssociations"].push(item.toJSON());
        }
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): InspectionPointPhotoListDto {
        const json = this.toJSON();
        let result = new InspectionPointPhotoListDto();
        result.init(json);
        return result;
    }
}

export interface IInspectionPointPhotoListDto {
    description: string | undefined;
    path: string | undefined;
    categoryName: string | undefined;
    categoryCode: string | undefined;
    inspectionPointName: string | undefined;
    inspectionPointCode: string | undefined;
    photoAssociations: PhotoAssociationListDto[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class ReportFileDto implements IReportFileDto {
    path: string | undefined;

    constructor(data?: IReportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
        }
    }

    static fromJS(data: any): ReportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data; 
    }

    clone(): ReportFileDto {
        const json = this.toJSON();
        let result = new ReportFileDto();
        result.init(json);
        return result;
    }
}

export interface IReportFileDto {
    path: string | undefined;
}

export class CommonIssueRequestDto implements ICommonIssueRequestDto {
    inspectionPointStatusId: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    countryCode: string | undefined;
    branchId: string | undefined;
    inspectorId: number | undefined;
    inspectionTypeId: string | undefined;
    vehicleStatus: VehicleStatus | undefined;

    constructor(data?: ICommonIssueRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionPointStatusId = data["inspectionPointStatusId"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.countryCode = data["countryCode"];
            this.branchId = data["branchId"];
            this.inspectorId = data["inspectorId"];
            this.inspectionTypeId = data["inspectionTypeId"];
            this.vehicleStatus = data["vehicleStatus"];
        }
    }

    static fromJS(data: any): CommonIssueRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommonIssueRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionPointStatusId"] = this.inspectionPointStatusId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["branchId"] = this.branchId;
        data["inspectorId"] = this.inspectorId;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["vehicleStatus"] = this.vehicleStatus;
        return data; 
    }

    clone(): CommonIssueRequestDto {
        const json = this.toJSON();
        let result = new CommonIssueRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICommonIssueRequestDto {
    inspectionPointStatusId: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    countryCode: string | undefined;
    branchId: string | undefined;
    inspectorId: number | undefined;
    inspectionTypeId: string | undefined;
    vehicleStatus: VehicleStatus | undefined;
}

export class ListResultDtoOfCommonIssuesListDto implements IListResultDtoOfCommonIssuesListDto {
    items: CommonIssuesListDto[] | undefined;

    constructor(data?: IListResultDtoOfCommonIssuesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CommonIssuesListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCommonIssuesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCommonIssuesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfCommonIssuesListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfCommonIssuesListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfCommonIssuesListDto {
    items: CommonIssuesListDto[] | undefined;
}

export class CommonIssuesListDto implements ICommonIssuesListDto {
    inspectionPointId: string | undefined;
    inspectionPointName: string | undefined;
    issueCount: number | undefined;

    constructor(data?: ICommonIssuesListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionPointId = data["inspectionPointId"];
            this.inspectionPointName = data["inspectionPointName"];
            this.issueCount = data["issueCount"];
        }
    }

    static fromJS(data: any): CommonIssuesListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommonIssuesListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionPointId"] = this.inspectionPointId;
        data["inspectionPointName"] = this.inspectionPointName;
        data["issueCount"] = this.issueCount;
        return data; 
    }

    clone(): CommonIssuesListDto {
        const json = this.toJSON();
        let result = new CommonIssuesListDto();
        result.init(json);
        return result;
    }
}

export interface ICommonIssuesListDto {
    inspectionPointId: string | undefined;
    inspectionPointName: string | undefined;
    issueCount: number | undefined;
}

export class ReportDataRequestDto implements IReportDataRequestDto {
    skipCount: number | undefined;
    maxResultCount: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    inspectionPointId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectionPointStatusid: string | undefined;
    vehicleStatus: ReportDataRequestDtoVehicleStatus | undefined;

    constructor(data?: IReportDataRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.branchId = data["branchId"];
            this.countryCode = data["countryCode"];
            this.inspectionPointId = data["inspectionPointId"];
            this.inspectionTypeId = data["inspectionTypeId"];
            this.inspectionPointStatusid = data["inspectionPointStatusid"];
            this.vehicleStatus = data["vehicleStatus"];
        }
    }

    static fromJS(data: any): ReportDataRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["branchId"] = this.branchId;
        data["countryCode"] = this.countryCode;
        data["inspectionPointId"] = this.inspectionPointId;
        data["inspectionTypeId"] = this.inspectionTypeId;
        data["inspectionPointStatusid"] = this.inspectionPointStatusid;
        data["vehicleStatus"] = this.vehicleStatus;
        return data; 
    }

    clone(): ReportDataRequestDto {
        const json = this.toJSON();
        let result = new ReportDataRequestDto();
        result.init(json);
        return result;
    }
}

export interface IReportDataRequestDto {
    skipCount: number | undefined;
    maxResultCount: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    inspectionPointId: string | undefined;
    inspectionTypeId: string | undefined;
    inspectionPointStatusid: string | undefined;
    vehicleStatus: ReportDataRequestDtoVehicleStatus | undefined;
}

export class PagedResultDtoOfReportDataListDto implements IPagedResultDtoOfReportDataListDto {
    totalCount: number | undefined;
    items: ReportDataListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReportDataListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ReportDataListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportDataListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportDataListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfReportDataListDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfReportDataListDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfReportDataListDto {
    totalCount: number | undefined;
    items: ReportDataListDto[] | undefined;
}

export class ReportDataListDto implements IReportDataListDto {
    inspectionId: string | undefined;
    siteId: string | undefined;
    siteName: string | undefined;
    reportNo: string | undefined;
    model: string | undefined;
    vehicleId: string | undefined;
    vehicleVIN: string | undefined;
    vehicleStockNumber: string | undefined;
    year: string | undefined;
    inspectionCreationDate: moment.Moment | undefined;
    counters: StatusCounter[] | undefined;
    anyCommentsPresent: boolean | undefined;
    anyPhotosPresent: boolean | undefined;

    constructor(data?: IReportDataListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inspectionId = data["inspectionId"];
            this.siteId = data["siteId"];
            this.siteName = data["siteName"];
            this.reportNo = data["reportNo"];
            this.model = data["model"];
            this.vehicleId = data["vehicleId"];
            this.vehicleVIN = data["vehicleVIN"];
            this.vehicleStockNumber = data["vehicleStockNumber"];
            this.year = data["year"];
            this.inspectionCreationDate = data["inspectionCreationDate"] ? moment(data["inspectionCreationDate"].toString()) : <any>undefined;
            if (data["counters"] && data["counters"].constructor === Array) {
                this.counters = [] as any;
                for (let item of data["counters"])
                    this.counters.push(StatusCounter.fromJS(item));
            }
            this.anyCommentsPresent = data["anyCommentsPresent"];
            this.anyPhotosPresent = data["anyPhotosPresent"];
        }
    }

    static fromJS(data: any): ReportDataListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inspectionId"] = this.inspectionId;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["reportNo"] = this.reportNo;
        data["model"] = this.model;
        data["vehicleId"] = this.vehicleId;
        data["vehicleVIN"] = this.vehicleVIN;
        data["vehicleStockNumber"] = this.vehicleStockNumber;
        data["year"] = this.year;
        data["inspectionCreationDate"] = this.inspectionCreationDate ? this.inspectionCreationDate.toISOString() : <any>undefined;
        if (this.counters && this.counters.constructor === Array) {
            data["counters"] = [];
            for (let item of this.counters)
                data["counters"].push(item.toJSON());
        }
        data["anyCommentsPresent"] = this.anyCommentsPresent;
        data["anyPhotosPresent"] = this.anyPhotosPresent;
        return data; 
    }

    clone(): ReportDataListDto {
        const json = this.toJSON();
        let result = new ReportDataListDto();
        result.init(json);
        return result;
    }
}

export interface IReportDataListDto {
    inspectionId: string | undefined;
    siteId: string | undefined;
    siteName: string | undefined;
    reportNo: string | undefined;
    model: string | undefined;
    vehicleId: string | undefined;
    vehicleVIN: string | undefined;
    vehicleStockNumber: string | undefined;
    year: string | undefined;
    inspectionCreationDate: moment.Moment | undefined;
    counters: StatusCounter[] | undefined;
    anyCommentsPresent: boolean | undefined;
    anyPhotosPresent: boolean | undefined;
}

export class StatusCounter implements IStatusCounter {
    id: string | undefined;
    key: string | undefined;
    value: number | undefined;

    constructor(data?: IStatusCounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): StatusCounter {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCounter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }

    clone(): StatusCounter {
        const json = this.toJSON();
        let result = new StatusCounter();
        result.init(json);
        return result;
    }
}

export interface IStatusCounter {
    id: string | undefined;
    key: string | undefined;
    value: number | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean | undefined;
    permissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.normalizedName = data["normalizedName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean | undefined;
    permissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean | undefined;
    permissions: string[] | undefined;
    id: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.normalizedName = data["normalizedName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isStatic: boolean | undefined;
    permissions: string[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class ListResultDtoOfPermissionDto implements IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IListResultDtoOfPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfPermissionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class Role implements IRole {
    description: string | undefined;
    normalizedName: string;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User | undefined;
    creatorUser: User | undefined;
    lastModifierUser: User | undefined;
    tenantId: number | undefined;
    name: string;
    displayName: string;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.normalizedName = data["normalizedName"];
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [] as any;
                for (let item of data["claims"])
                    this.claims.push(RoleClaim.fromJS(item));
            }
            this.concurrencyStamp = data["concurrencyStamp"];
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(RolePermissionSetting.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["normalizedName"] = this.normalizedName;
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    description: string | undefined;
    normalizedName: string;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User | undefined;
    creatorUser: User | undefined;
    lastModifierUser: User | undefined;
    tenantId: number | undefined;
    name: string;
    displayName: string;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RoleClaim implements IRoleClaim {
    tenantId: number | undefined;
    roleId: number | undefined;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.roleId = data["roleId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleClaim {
        const json = this.toJSON();
        let result = new RoleClaim();
        result.init(json);
        return result;
    }
}

export interface IRoleClaim {
    tenantId: number | undefined;
    roleId: number | undefined;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    roleId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }

    clone(): RolePermissionSetting {
        const json = this.toJSON();
        let result = new RolePermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IRolePermissionSetting {
    roleId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PagedResultDtoOfRoleDto implements IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string] : boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {} as any;
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string] : boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    id: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.accessType = data["accessType"];
            this.branchId = data["branchId"];
            this.countryCode = data["countryCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["accessType"] = this.accessType;
        data["branchId"] = this.branchId;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class SplatDiagramPointRequestDto implements ISplatDiagramPointRequestDto {
    name: string | undefined;
    xAxisPosition: number | undefined;
    yAxisPosition: number | undefined;
    comment: string | undefined;
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;

    constructor(data?: ISplatDiagramPointRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.xAxisPosition = data["xAxisPosition"];
            this.yAxisPosition = data["yAxisPosition"];
            this.comment = data["comment"];
            this.inspectionId = data["inspectionId"];
            this.inspectionPointId = data["inspectionPointId"];
        }
    }

    static fromJS(data: any): SplatDiagramPointRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplatDiagramPointRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["xAxisPosition"] = this.xAxisPosition;
        data["yAxisPosition"] = this.yAxisPosition;
        data["comment"] = this.comment;
        data["inspectionId"] = this.inspectionId;
        data["inspectionPointId"] = this.inspectionPointId;
        return data; 
    }

    clone(): SplatDiagramPointRequestDto {
        const json = this.toJSON();
        let result = new SplatDiagramPointRequestDto();
        result.init(json);
        return result;
    }
}

export interface ISplatDiagramPointRequestDto {
    name: string | undefined;
    xAxisPosition: number | undefined;
    yAxisPosition: number | undefined;
    comment: string | undefined;
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;
}

export class SplatDiagramPointListDto implements ISplatDiagramPointListDto {
    name: string | undefined;
    id: string | undefined;
    xAxisPosition: number | undefined;
    yAxisPosition: number | undefined;
    comment: string | undefined;
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;

    constructor(data?: ISplatDiagramPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
            this.xAxisPosition = data["xAxisPosition"];
            this.yAxisPosition = data["yAxisPosition"];
            this.comment = data["comment"];
            this.inspectionId = data["inspectionId"];
            this.inspectionPointId = data["inspectionPointId"];
        }
    }

    static fromJS(data: any): SplatDiagramPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplatDiagramPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["xAxisPosition"] = this.xAxisPosition;
        data["yAxisPosition"] = this.yAxisPosition;
        data["comment"] = this.comment;
        data["inspectionId"] = this.inspectionId;
        data["inspectionPointId"] = this.inspectionPointId;
        return data; 
    }

    clone(): SplatDiagramPointListDto {
        const json = this.toJSON();
        let result = new SplatDiagramPointListDto();
        result.init(json);
        return result;
    }
}

export interface ISplatDiagramPointListDto {
    name: string | undefined;
    id: string | undefined;
    xAxisPosition: number | undefined;
    yAxisPosition: number | undefined;
    comment: string | undefined;
    inspectionId: string | undefined;
    inspectionPointId: string | undefined;
}

export class ListResultDtoOfSplatDiagramPointListDto implements IListResultDtoOfSplatDiagramPointListDto {
    items: SplatDiagramPointListDto[] | undefined;

    constructor(data?: IListResultDtoOfSplatDiagramPointListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(SplatDiagramPointListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSplatDiagramPointListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSplatDiagramPointListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfSplatDiagramPointListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfSplatDiagramPointListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfSplatDiagramPointListDto {
    items: SplatDiagramPointListDto[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    logoImagePath: string | undefined;
    customBaseColor: string | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.logoImagePath = data["logoImagePath"];
            this.customBaseColor = data["customBaseColor"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["logoImagePath"] = this.logoImagePath;
        data["customBaseColor"] = this.customBaseColor;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    logoImagePath: string | undefined;
    customBaseColor: string | undefined;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    logoImagePath: string | undefined;
    customBaseColor: string | undefined;
    id: number | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.logoImagePath = data["logoImagePath"];
            this.customBaseColor = data["customBaseColor"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["logoImagePath"] = this.logoImagePath;
        data["customBaseColor"] = this.customBaseColor;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    logoImagePath: string | undefined;
    customBaseColor: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.rememberClient = data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.emailAddress = data["emailAddress"];
            this.isActive = data["isActive"];
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = data["password"];
            this.accessType = data["accessType"];
            this.branchId = data["branchId"];
            this.countryCode = data["countryCode"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["accessType"] = this.accessType;
        data["branchId"] = this.branchId;
        data["countryCode"] = this.countryCode;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    roleNames: string[] | undefined;
    id: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.emailAddress = data["emailAddress"];
            this.isActive = data["isActive"];
            this.fullName = data["fullName"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.accessType = data["accessType"];
            this.branchId = data["branchId"];
            this.countryCode = data["countryCode"];
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["accessType"] = this.accessType;
        data["branchId"] = this.branchId;
        data["countryCode"] = this.countryCode;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    accessType: number | undefined;
    branchId: string | undefined;
    countryCode: string | undefined;
    roleNames: string[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfRoleDto implements IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;
}

export class ListResultDtoOfVehicleMakeModelListDto implements IListResultDtoOfVehicleMakeModelListDto {
    items: VehicleMakeModelListDto[] | undefined;

    constructor(data?: IListResultDtoOfVehicleMakeModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(VehicleMakeModelListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVehicleMakeModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfVehicleMakeModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfVehicleMakeModelListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfVehicleMakeModelListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfVehicleMakeModelListDto {
    items: VehicleMakeModelListDto[] | undefined;
}

export class VehicleMakeModelListDto implements IVehicleMakeModelListDto {
    id: string | undefined;
    type: string | undefined;
    code: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    displayIndex: number | undefined;
    isActive: boolean | undefined;

    constructor(data?: IVehicleMakeModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.type = data["type"];
            this.code = data["code"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.value = data["value"];
            this.displayIndex = data["displayIndex"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): VehicleMakeModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleMakeModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["displayIndex"] = this.displayIndex;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): VehicleMakeModelListDto {
        const json = this.toJSON();
        let result = new VehicleMakeModelListDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleMakeModelListDto {
    id: string | undefined;
    type: string | undefined;
    code: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    displayIndex: number | undefined;
    isActive: boolean | undefined;
}

export class ListResultDtoOfVehicleModelListDto implements IListResultDtoOfVehicleModelListDto {
    items: VehicleModelListDto[] | undefined;

    constructor(data?: IListResultDtoOfVehicleModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(VehicleModelListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVehicleModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfVehicleModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfVehicleModelListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfVehicleModelListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfVehicleModelListDto {
    items: VehicleModelListDto[] | undefined;
}

export class VehicleModelListDto implements IVehicleModelListDto {
    id: string | undefined;
    type: string | undefined;
    code: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    displayIndex: number | undefined;
    vehicleMakeId: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: IVehicleModelListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.type = data["type"];
            this.code = data["code"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.value = data["value"];
            this.displayIndex = data["displayIndex"];
            this.vehicleMakeId = data["vehicleMakeId"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): VehicleModelListDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["displayIndex"] = this.displayIndex;
        data["vehicleMakeId"] = this.vehicleMakeId;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): VehicleModelListDto {
        const json = this.toJSON();
        let result = new VehicleModelListDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleModelListDto {
    id: string | undefined;
    type: string | undefined;
    code: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    displayIndex: number | undefined;
    vehicleMakeId: string | undefined;
    isActive: boolean | undefined;
}

export class VehicleDto implements IVehicleDto {
    customerId: string | undefined;
    engineNumber: string | undefined;
    primaryColorId: string | undefined;
    secondaryColorId: string | undefined;
    vehicleMakeId: string | undefined;
    vehicleModelId: string | undefined;
    subModel: string | undefined;
    yearId: string | undefined;
    cc: string | undefined;
    transmissionTypeId: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    vehicleStatus: VehicleDtoVehicleStatus | undefined;
    registrationNumber: string | undefined;
    registrationExpiry: moment.Moment | undefined;
    cylinders: number | undefined;
    odometer: number | undefined;
    rucExpiry: moment.Moment | undefined;
    lastService: moment.Moment | undefined;
    firstRegisteredInNZ: moment.Moment | undefined;
    fuelSystemId: string | undefined;
    fuelTypeId: string | undefined;
    originId: string | undefined;
    bodyShapeId: string | undefined;
    wofExpiry: moment.Moment | undefined;
    numberOfSeats: number | undefined;
    modifications: string | undefined;
    comment: string | undefined;
    timingBelt: string | undefined;
    standardMarkingTyresChoice: string | undefined;
    standardMarkingTyresInfo: string | undefined;
    standardMarkingLightsChoice: string | undefined;
    standardMarkingLightsInfo: string | undefined;
    standardMarkingGlazingChoice: string | undefined;
    standardMarkingGlazingInfo: string | undefined;
    make: LK_GenericLookups | undefined;
    model: LK_GenericLookups | undefined;
    colorPrimary: LK_GenericLookups | undefined;
    colorSecondary: LK_GenericLookups | undefined;
    year: LK_GenericLookups | undefined;
    bodyShape: LK_GenericLookups | undefined;
    transType: LK_GenericLookups | undefined;
    fuelSystem: LK_GenericLookups | undefined;
    fuelType: LK_GenericLookups | undefined;
    origin: LK_GenericLookups | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.engineNumber = data["engineNumber"];
            this.primaryColorId = data["primaryColorId"];
            this.secondaryColorId = data["secondaryColorId"];
            this.vehicleMakeId = data["vehicleMakeId"];
            this.vehicleModelId = data["vehicleModelId"];
            this.subModel = data["subModel"];
            this.yearId = data["yearId"];
            this.cc = data["cc"];
            this.transmissionTypeId = data["transmissionTypeId"];
            this.stockNumber = data["stockNumber"];
            this.vinNumber = data["vinNumber"];
            this.vehicleStatus = data["vehicleStatus"];
            this.registrationNumber = data["registrationNumber"];
            this.registrationExpiry = data["registrationExpiry"] ? moment(data["registrationExpiry"].toString()) : <any>undefined;
            this.cylinders = data["cylinders"];
            this.odometer = data["odometer"];
            this.rucExpiry = data["rucExpiry"] ? moment(data["rucExpiry"].toString()) : <any>undefined;
            this.lastService = data["lastService"] ? moment(data["lastService"].toString()) : <any>undefined;
            this.firstRegisteredInNZ = data["firstRegisteredInNZ"] ? moment(data["firstRegisteredInNZ"].toString()) : <any>undefined;
            this.fuelSystemId = data["fuelSystemId"];
            this.fuelTypeId = data["fuelTypeId"];
            this.originId = data["originId"];
            this.bodyShapeId = data["bodyShapeId"];
            this.wofExpiry = data["wofExpiry"] ? moment(data["wofExpiry"].toString()) : <any>undefined;
            this.numberOfSeats = data["numberOfSeats"];
            this.modifications = data["modifications"];
            this.comment = data["comment"];
            this.timingBelt = data["timingBelt"];
            this.standardMarkingTyresChoice = data["standardMarkingTyresChoice"];
            this.standardMarkingTyresInfo = data["standardMarkingTyresInfo"];
            this.standardMarkingLightsChoice = data["standardMarkingLightsChoice"];
            this.standardMarkingLightsInfo = data["standardMarkingLightsInfo"];
            this.standardMarkingGlazingChoice = data["standardMarkingGlazingChoice"];
            this.standardMarkingGlazingInfo = data["standardMarkingGlazingInfo"];
            this.make = data["make"] ? LK_GenericLookups.fromJS(data["make"]) : <any>undefined;
            this.model = data["model"] ? LK_GenericLookups.fromJS(data["model"]) : <any>undefined;
            this.colorPrimary = data["colorPrimary"] ? LK_GenericLookups.fromJS(data["colorPrimary"]) : <any>undefined;
            this.colorSecondary = data["colorSecondary"] ? LK_GenericLookups.fromJS(data["colorSecondary"]) : <any>undefined;
            this.year = data["year"] ? LK_GenericLookups.fromJS(data["year"]) : <any>undefined;
            this.bodyShape = data["bodyShape"] ? LK_GenericLookups.fromJS(data["bodyShape"]) : <any>undefined;
            this.transType = data["transType"] ? LK_GenericLookups.fromJS(data["transType"]) : <any>undefined;
            this.fuelSystem = data["fuelSystem"] ? LK_GenericLookups.fromJS(data["fuelSystem"]) : <any>undefined;
            this.fuelType = data["fuelType"] ? LK_GenericLookups.fromJS(data["fuelType"]) : <any>undefined;
            this.origin = data["origin"] ? LK_GenericLookups.fromJS(data["origin"]) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["engineNumber"] = this.engineNumber;
        data["primaryColorId"] = this.primaryColorId;
        data["secondaryColorId"] = this.secondaryColorId;
        data["vehicleMakeId"] = this.vehicleMakeId;
        data["vehicleModelId"] = this.vehicleModelId;
        data["subModel"] = this.subModel;
        data["yearId"] = this.yearId;
        data["cc"] = this.cc;
        data["transmissionTypeId"] = this.transmissionTypeId;
        data["stockNumber"] = this.stockNumber;
        data["vinNumber"] = this.vinNumber;
        data["vehicleStatus"] = this.vehicleStatus;
        data["registrationNumber"] = this.registrationNumber;
        data["registrationExpiry"] = this.registrationExpiry ? this.registrationExpiry.toISOString() : <any>undefined;
        data["cylinders"] = this.cylinders;
        data["odometer"] = this.odometer;
        data["rucExpiry"] = this.rucExpiry ? this.rucExpiry.toISOString() : <any>undefined;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["firstRegisteredInNZ"] = this.firstRegisteredInNZ ? this.firstRegisteredInNZ.toISOString() : <any>undefined;
        data["fuelSystemId"] = this.fuelSystemId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["originId"] = this.originId;
        data["bodyShapeId"] = this.bodyShapeId;
        data["wofExpiry"] = this.wofExpiry ? this.wofExpiry.toISOString() : <any>undefined;
        data["numberOfSeats"] = this.numberOfSeats;
        data["modifications"] = this.modifications;
        data["comment"] = this.comment;
        data["timingBelt"] = this.timingBelt;
        data["standardMarkingTyresChoice"] = this.standardMarkingTyresChoice;
        data["standardMarkingTyresInfo"] = this.standardMarkingTyresInfo;
        data["standardMarkingLightsChoice"] = this.standardMarkingLightsChoice;
        data["standardMarkingLightsInfo"] = this.standardMarkingLightsInfo;
        data["standardMarkingGlazingChoice"] = this.standardMarkingGlazingChoice;
        data["standardMarkingGlazingInfo"] = this.standardMarkingGlazingInfo;
        data["make"] = this.make ? this.make.toJSON() : <any>undefined;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["colorPrimary"] = this.colorPrimary ? this.colorPrimary.toJSON() : <any>undefined;
        data["colorSecondary"] = this.colorSecondary ? this.colorSecondary.toJSON() : <any>undefined;
        data["year"] = this.year ? this.year.toJSON() : <any>undefined;
        data["bodyShape"] = this.bodyShape ? this.bodyShape.toJSON() : <any>undefined;
        data["transType"] = this.transType ? this.transType.toJSON() : <any>undefined;
        data["fuelSystem"] = this.fuelSystem ? this.fuelSystem.toJSON() : <any>undefined;
        data["fuelType"] = this.fuelType ? this.fuelType.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): VehicleDto {
        const json = this.toJSON();
        let result = new VehicleDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDto {
    customerId: string | undefined;
    engineNumber: string | undefined;
    primaryColorId: string | undefined;
    secondaryColorId: string | undefined;
    vehicleMakeId: string | undefined;
    vehicleModelId: string | undefined;
    subModel: string | undefined;
    yearId: string | undefined;
    cc: string | undefined;
    transmissionTypeId: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    vehicleStatus: VehicleDtoVehicleStatus | undefined;
    registrationNumber: string | undefined;
    registrationExpiry: moment.Moment | undefined;
    cylinders: number | undefined;
    odometer: number | undefined;
    rucExpiry: moment.Moment | undefined;
    lastService: moment.Moment | undefined;
    firstRegisteredInNZ: moment.Moment | undefined;
    fuelSystemId: string | undefined;
    fuelTypeId: string | undefined;
    originId: string | undefined;
    bodyShapeId: string | undefined;
    wofExpiry: moment.Moment | undefined;
    numberOfSeats: number | undefined;
    modifications: string | undefined;
    comment: string | undefined;
    timingBelt: string | undefined;
    standardMarkingTyresChoice: string | undefined;
    standardMarkingTyresInfo: string | undefined;
    standardMarkingLightsChoice: string | undefined;
    standardMarkingLightsInfo: string | undefined;
    standardMarkingGlazingChoice: string | undefined;
    standardMarkingGlazingInfo: string | undefined;
    make: LK_GenericLookups | undefined;
    model: LK_GenericLookups | undefined;
    colorPrimary: LK_GenericLookups | undefined;
    colorSecondary: LK_GenericLookups | undefined;
    year: LK_GenericLookups | undefined;
    bodyShape: LK_GenericLookups | undefined;
    transType: LK_GenericLookups | undefined;
    fuelSystem: LK_GenericLookups | undefined;
    fuelType: LK_GenericLookups | undefined;
    origin: LK_GenericLookups | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class LK_GenericLookups implements ILK_GenericLookups {
    type: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    parentId: string | undefined;
    displayIndex: number | undefined;
    displayColor: string | undefined;
    parent: LK_GenericLookups | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;

    constructor(data?: ILK_GenericLookups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.value = data["value"];
            this.parentId = data["parentId"];
            this.displayIndex = data["displayIndex"];
            this.displayColor = data["displayColor"];
            this.parent = data["parent"] ? LK_GenericLookups.fromJS(data["parent"]) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LK_GenericLookups {
        data = typeof data === 'object' ? data : {};
        let result = new LK_GenericLookups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["value"] = this.value;
        data["parentId"] = this.parentId;
        data["displayIndex"] = this.displayIndex;
        data["displayColor"] = this.displayColor;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): LK_GenericLookups {
        const json = this.toJSON();
        let result = new LK_GenericLookups();
        result.init(json);
        return result;
    }
}

export interface ILK_GenericLookups {
    type: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    value: string | undefined;
    parentId: string | undefined;
    displayIndex: number | undefined;
    displayColor: string | undefined;
    parent: LK_GenericLookups | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    tenantId: number | undefined;
    id: string | undefined;
}

export class CreateVehicleRequestDto implements ICreateVehicleRequestDto {
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: CreateVehicleRequestDtoVehicleStatus | undefined;

    constructor(data?: ICreateVehicleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockNumber = data["stockNumber"];
            this.vinNumber = data["vinNumber"];
            this.registrationNumber = data["registrationNumber"];
            this.vehicleStatus = data["vehicleStatus"];
        }
    }

    static fromJS(data: any): CreateVehicleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockNumber"] = this.stockNumber;
        data["vinNumber"] = this.vinNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["vehicleStatus"] = this.vehicleStatus;
        return data; 
    }

    clone(): CreateVehicleRequestDto {
        const json = this.toJSON();
        let result = new CreateVehicleRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleRequestDto {
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: CreateVehicleRequestDtoVehicleStatus | undefined;
}

export class UpdateVehicleRequestDto implements IUpdateVehicleRequestDto {
    id: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: UpdateVehicleRequestDtoVehicleStatus | undefined;

    constructor(data?: IUpdateVehicleRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.stockNumber = data["stockNumber"];
            this.vinNumber = data["vinNumber"];
            this.registrationNumber = data["registrationNumber"];
            this.vehicleStatus = data["vehicleStatus"];
        }
    }

    static fromJS(data: any): UpdateVehicleRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockNumber"] = this.stockNumber;
        data["vinNumber"] = this.vinNumber;
        data["registrationNumber"] = this.registrationNumber;
        data["vehicleStatus"] = this.vehicleStatus;
        return data; 
    }

    clone(): UpdateVehicleRequestDto {
        const json = this.toJSON();
        let result = new UpdateVehicleRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleRequestDto {
    id: string | undefined;
    stockNumber: string | undefined;
    vinNumber: string | undefined;
    registrationNumber: string | undefined;
    vehicleStatus: UpdateVehicleRequestDtoVehicleStatus | undefined;
}

export class VehicleInspectionVersionSearchRequestDto implements IVehicleInspectionVersionSearchRequestDto {
    searchString: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IVehicleInspectionVersionSearchRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.searchString = data["searchString"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): VehicleInspectionVersionSearchRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInspectionVersionSearchRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchString"] = this.searchString;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): VehicleInspectionVersionSearchRequestDto {
        const json = this.toJSON();
        let result = new VehicleInspectionVersionSearchRequestDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleInspectionVersionSearchRequestDto {
    searchString: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ListResultDtoOfVehicleInspectionVersionListDto implements IListResultDtoOfVehicleInspectionVersionListDto {
    items: VehicleInspectionVersionListDto[] | undefined;

    constructor(data?: IListResultDtoOfVehicleInspectionVersionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(VehicleInspectionVersionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfVehicleInspectionVersionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfVehicleInspectionVersionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfVehicleInspectionVersionListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfVehicleInspectionVersionListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfVehicleInspectionVersionListDto {
    items: VehicleInspectionVersionListDto[] | undefined;
}

export class VehicleInspectionVersionListDto implements IVehicleInspectionVersionListDto {
    vehicleId: string | undefined;
    registrationNumber: string | undefined;
    vin: string | undefined;
    stockNumber: string | undefined;
    numberOfPastInspections: number | undefined;
    activeInspectionId: string | undefined;
    isHavingActiveInspection: boolean | undefined;

    constructor(data?: IVehicleInspectionVersionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vehicleId = data["vehicleId"];
            this.registrationNumber = data["registrationNumber"];
            this.vin = data["vin"];
            this.stockNumber = data["stockNumber"];
            this.numberOfPastInspections = data["numberOfPastInspections"];
            this.activeInspectionId = data["activeInspectionId"];
            this.isHavingActiveInspection = data["isHavingActiveInspection"];
        }
    }

    static fromJS(data: any): VehicleInspectionVersionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInspectionVersionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["registrationNumber"] = this.registrationNumber;
        data["vin"] = this.vin;
        data["stockNumber"] = this.stockNumber;
        data["numberOfPastInspections"] = this.numberOfPastInspections;
        data["activeInspectionId"] = this.activeInspectionId;
        data["isHavingActiveInspection"] = this.isHavingActiveInspection;
        return data; 
    }

    clone(): VehicleInspectionVersionListDto {
        const json = this.toJSON();
        let result = new VehicleInspectionVersionListDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleInspectionVersionListDto {
    vehicleId: string | undefined;
    registrationNumber: string | undefined;
    vin: string | undefined;
    stockNumber: string | undefined;
    numberOfPastInspections: number | undefined;
    activeInspectionId: string | undefined;
    isHavingActiveInspection: boolean | undefined;
}

export class CreateVehicleModelDto implements ICreateVehicleModelDto {
    makeName: string;
    modelName: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: ICreateVehicleModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.makeName = data["makeName"];
            this.modelName = data["modelName"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateVehicleModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["makeName"] = this.makeName;
        data["modelName"] = this.modelName;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateVehicleModelDto {
        const json = this.toJSON();
        let result = new CreateVehicleModelDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleModelDto {
    makeName: string;
    modelName: string | undefined;
    isActive: boolean | undefined;
}

export class VehicleModelDto implements IVehicleModelDto {
    makeId: string | undefined;
    makeName: string;
    modelName: string;
    isActive: boolean | undefined;
    id: string | undefined;

    constructor(data?: IVehicleModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.makeId = data["makeId"];
            this.makeName = data["makeName"];
            this.modelName = data["modelName"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VehicleModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["makeId"] = this.makeId;
        data["makeName"] = this.makeName;
        data["modelName"] = this.modelName;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): VehicleModelDto {
        const json = this.toJSON();
        let result = new VehicleModelDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleModelDto {
    makeId: string | undefined;
    makeName: string;
    modelName: string;
    isActive: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfVehicleModelDto implements IPagedResultDtoOfVehicleModelDto {
    totalCount: number | undefined;
    items: VehicleModelDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVehicleModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(VehicleModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVehicleModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVehicleModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfVehicleModelDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfVehicleModelDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfVehicleModelDto {
    totalCount: number | undefined;
    items: VehicleModelDto[] | undefined;
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum VehicleStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum ReportDataRequestDtoVehicleStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum VehicleDtoVehicleStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum CreateVehicleRequestDtoVehicleStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UpdateVehicleRequestDtoVehicleStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}